unit Planta;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.REST, WEBLib.JSON, WEBLib.CDS,
  WEBLib.Actions, WEBLib.Devices, WEBLib.JQCtrls, WEBLib.ExtCtrls,
  Vcl.Imaging.pngimage, WEBLib.Buttons, WEBLib.ComCtrls;


type
  TuPlanta = class(TForm)
    WebConn: TClientConnection;
    WebDTS: TDataSource;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    CloseData: TButton;
    RS: TEdit;
    WebPanel2: TPanel;
    mCNPJ: TDBEdit;
    mMarca: TDBEdit;
    mCEP: TDBEdit;
    mComplemento: TDBEdit;
    WebLabel8: TLabel;
    WebLabel7: TLabel;
    WebLabel6: TLabel;
    WebLabel5: TLabel;
    WebLabel2: TLabel;
    btnPesquisar: TBitBtn;
    upPlanta: THttpRequest;
    mIdPess: TDBEdit;
    mRazao: TDBEdit;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    Nav01: TDBNavigator;
    Msg01: TMessageDlg;
    WebLabel11: TLabel;
    btnExcluir: TBitBtn;
    WebLabel12: TLabel;
    mEmailC: TDBEdit;
    mEmailNFe: TDBEdit;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    mInscricaoEST: TDBEdit;
    WebLabel13: TLabel;
    mCidade: TDBEdit;
    WebLabel14: TLabel;
    mEstado: TDBEdit;
    cad_lMUNI: TBitBtn;
    mLogra: TDBEdit;
    mTRONCO: TDBEdit;
    WebLabel15: TLabel;
    mAtiva: TDBEdit;
    WebLabel16: TLabel;
    WebDBEdit1: TDBEdit;
    WebLabel17: TLabel;
    mIBGE: TDBEdit;
    WebLabel18: TLabel;
    mContatoP: TDBEdit;
    WebClientDS: TClientDataSet;
    WebClientDSidpess: TIntegerField;
    WebClientDSmarca: TStringField;
    WebClientDSrazao: TStringField;
    WebClientDSidgrupo: TIntegerField;
    WebClientDScnpj: TStringField;
    WebClientDScnpj_serie: TIntegerField;
    WebClientDSinscricaoest: TStringField;
    WebClientDSendereco: TStringField;
    WebClientDStronco: TStringField;
    WebClientDSstatus: TStringField;
    WebClientDSbairro: TStringField;
    WebClientDScidade: TStringField;
    WebClientDScep: TStringField;
    WebClientDSestado: TStringField;
    WebClientDScomplemento: TStringField;
    WebClientDSativa: TBooleanField;
    WebClientDSfilial: TBooleanField;
    WebClientDSemailc: TStringField;
    WebClientDSnfe_email00: TStringField;
    WebClientDScontatop: TStringField;
    WebClientDSsim_cpf: TBooleanField;
    WebClientDSbacen: TIntegerField;
    WebClientDSidcchain: TIntegerField;
    WebClientDSidseg: TIntegerField;
    WebClientDSdatacad: TDateTimeField;
    WebClientDSibge: TStringField;
    WebClientDSnfe_regimefiscal: TIntegerField;
    WebClientDSequalcmcarvalho: TBooleanField;
    WebClientDSok_cliente: TBooleanField;
    WebClientDSok_forne: TBooleanField;
    WebClientDSok_transp: TBooleanField;
    WebClientDSok_repres: TBooleanField;
    WebClientDSok_vend: TBooleanField;
    WebClientDSok_compra: TBooleanField;
    WebClientDSok_montadora: TBooleanField;
    WebClientDSok_func: TBooleanField;
    WebClientDSok_ppilha: TIntegerField;
    WebLabel19: TLabel;
    mRegime: TDBEdit;
    cRegimeFiscal: TComboBox;
    WebLabel20: TLabel;
    WebClientDSinscricaom: TStringField;
    WebClientDSinscricaoccm: TStringField;
    WebClientDSnosso_num: TStringField;
    WebClientDSduns_number: TStringField;
    WebClientDScpostal: TStringField;
    WebClientDSendcob: TStringField;
    WebClientDSmunicob: TStringField;
    WebClientDScepcob: TStringField;
    WebClientDSbaicob: TStringField;
    WebClientDSufcob: TStringField;
    WebClientDSendent: TStringField;
    WebClientDScepent: TStringField;
    WebClientDSbaient: TStringField;
    WebClientDSufent: TStringField;
    WebClientDScident: TStringField;
    WebClientDStipopj: TIntegerField;
    WebClientDStipovenda: TIntegerField;
    WebClientDSobspj: TStringField;
    WebClientDSnfserieedi: TStringField;
    WebClientDSbvqi: TBooleanField;
    WebClientDSconfere_carga: TBooleanField;
    WebClientDSnato: TIntegerField;
    WebClientDSregimefiscal: TStringField;
    WebClientDScontadeb_cm: TIntegerField;
    WebClientDScontacred_cs: TIntegerField;
    WebClientDScontacred_vp: TIntegerField;
    WebClientDScancelado: TBooleanField;
    WebClientDSfornecabc: TStringField;
    WebClientDSclienteabc: TStringField;
    WebClientDSidbco: TIntegerField;
    WebClientDSidtpgto: TIntegerField;
    WebClientDSidtpgtocc: TIntegerField;
    WebClientDSidtpgtocd: TIntegerField;
    WebClientDSpedeae5: TIntegerField;
    WebClientDSpedeae9: TIntegerField;
    WebClientDSidformav: TIntegerField;
    WebClientDSidformac: TIntegerField;
    WebClientDSvdm4: TIntegerField;
    WebClientDSqdm4: TIntegerField;
    WebClientDSfreq4m: TIntegerField;
    WebClientDSqpmatr: TIntegerField;
    WebClientDSqpm01: TIntegerField;
    WebClientDSqpm02: TIntegerField;
    WebClientDSqpm03: TIntegerField;
    WebClientDSqpm04: TIntegerField;
    WebClientDSqpm05: TIntegerField;
    WebClientDSqpm06: TIntegerField;
    WebClientDSqpm07: TIntegerField;
    WebClientDSqpm08: TIntegerField;
    WebClientDSqpm09: TIntegerField;
    WebClientDSqpm10: TIntegerField;
    WebClientDSqpm11: TIntegerField;
    WebClientDSqpm12: TIntegerField;
    WebClientDSvps11: TIntegerField;
    WebClientDSvps12: TIntegerField;
    WebClientDSvps13: TIntegerField;
    WebClientDSvps14: TIntegerField;
    WebClientDSvps15: TIntegerField;
    WebClientDSvpmatr: TIntegerField;
    WebClientDSvpm01: TIntegerField;
    WebClientDSvpm02: TIntegerField;
    WebClientDSvpm03: TIntegerField;
    WebClientDSvpm04: TIntegerField;
    WebClientDSvpm05: TIntegerField;
    WebClientDSvpm06: TIntegerField;
    WebClientDSvpm07: TIntegerField;
    WebClientDSvpm08: TIntegerField;
    WebClientDSvpm09: TIntegerField;
    WebClientDSvpm10: TIntegerField;
    WebClientDSvpm11: TIntegerField;
    WebClientDSvpm12: TIntegerField;
    WebClientDSvpmatrliq: TIntegerField;
    WebClientDSvpm01liq: TIntegerField;
    WebClientDSvpm02liq: TIntegerField;
    WebClientDSvpm03liq: TIntegerField;
    WebClientDSvpm04liq: TIntegerField;
    WebClientDSvpm05liq: TIntegerField;
    WebClientDSvpm06liq: TIntegerField;
    WebClientDSvpm07liq: TIntegerField;
    WebClientDSvpm08liq: TIntegerField;
    WebClientDSvpm09liq: TIntegerField;
    WebClientDSvpm10liq: TIntegerField;
    WebClientDSvpm11liq: TIntegerField;
    WebClientDSvpm12liq: TIntegerField;
    WebClientDSqvano: TIntegerField;
    WebClientDSpqvano: TIntegerField;
    WebClientDSfone: TStringField;
    WebClientDSfax: TStringField;
    WebClientDSemaile: TStringField;
    WebClientDSemailct: TStringField;
    WebClientDStipo_qc: TIntegerField;
    WebClientDSicm_compra: TIntegerField;
    WebClientDSrespcad: TStringField;
    WebClientDSciclo_numped: TIntegerField;
    WebClientDScode_transp: TIntegerField;
    WebClientDScodev_cfop: TIntegerField;
    WebClientDScodec_cfop: TIntegerField;
    WebClientDSnfe_assunto: TStringField;
    WebClientDSnfe_textoemail: TStringField;
    WebClientDScontatom: TStringField;
    WebClientDSsim_mala: TBooleanField;
    WebClientDSnfe_amp: TIntegerField;
    WebClientDSrestr_fatmsg00: TStringField;
    WebClientDSrestr_fatflag00: TIntegerField;
    WebClientDSinscritoie: TBooleanField;
    WebClientDSmkp: TIntegerField;
    WebClientDSsuframa: TStringField;
    WebClientDSsipi_pmp: TIntegerField;
    WebClientDSidvendedor: TIntegerField;
    WebClientDScomissao: TIntegerField;
    WebClientDSbaixarnfe_filhos: TIntegerField;
    WebClientDSnfe_tpfrete: TIntegerField;
    WebClientDSp_pis: TIntegerField;
    WebClientDSp_cofins: TIntegerField;
    WebClientDSp_iss: TIntegerField;
    WebClientDSp_inss: TIntegerField;
    WebClientDSp_csl: TIntegerField;
    WebClientDSp_ir: TIntegerField;
    WebClientDSp_pispasep: TIntegerField;
    WebClientDSidbcod: TIntegerField;
    WebClientDScredita_pis: TBooleanField;
    WebClientDScredita_cofins: TBooleanField;
    WebClientDScreditap_pis: TFloatField;
    WebClientDScreditap_cofins: TFloatField;
    WebClientDStravap: TIntegerField;
    WebClientDSexnitemped: TIntegerField;
    WebClientDStnitemped: TIntegerField;
    WebClientDSpdesc: TIntegerField;
    WebClientDSsim_cfinal: TBooleanField;
    WebClientDSidcnt: TIntegerField;
    WebClientDSautoexecute: TIntegerField;
    WebClientDSsim_deljit: TIntegerField;
    WebClientDSsim_delfor: TIntegerField;
    WebClientDSsim_excel: TIntegerField;
    WebClientDSsim_manual: TIntegerField;
    WebClientDSidpedf: TIntegerField;
    procedure WebFormHashChange(Sender: TObject; oldURL, newURL: string);
    procedure CloseDataClick(Sender: TObject);
    [async] procedure btnPesquisarClick(Sender: TObject); async;
    [async]
    [async]
    [async]
    [async]
    procedure CriterioKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState); async;
    procedure WebClientDSBeforePost(DataSet: TDataSet);
    [async] procedure Nav01Post(Sender: TObject); async;
    [async]
    procedure btnExcluirClick(Sender: TObject); async;
    procedure mMarcaKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure mCNPJKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure mRazaoKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure cRegimeFiscalClick(Sender: TObject);
    procedure WebDTSDataChange(Sender: TObject; Field: TField);
    [async]

  private
        { Private declarations }
        xCol, xRow: integer;
        xJSON: string;
        procedure AfterEdit;
  public

  protected procedure LoadDFMValues; override; end;



var
  uPlanta: TuPlanta;

implementation


{$R *.dfm}

uses
  uFrmMain;

const
  TOTAL_USERS = 1000;

procedure TuPlanta.AfterEdit;
var
  DataCAD: string;
begin
    // ISO8601 (e.g. 2010-10-12T10:12:23
    DataCAD:=
    FormatDateTime('yyyy',Now()) + '-' +
    FormatDateTime('mm',Now()) + '-' +
    FormatDateTime('dd',Now()) + 'T' +
    FormatDateTime('hh',Now()) + ':' +
    FormatDateTime('mm',Now()) + ':' +
    FormatDateTime('ss',Now());


    //Montando o JASON
    xJSON:=
    '{"marca": "' + mMarca.Text + '",'+
    '"razao": "' + mRazao.Text + '",'+
    '"cnpj": "' + mCNPJ.Text + '",'+
    '"cidade": "' + mCidade.Text + '",'+
    '"datacad": "' + DataCAD + '",'+
    '"inscricaoest": "' + mInscricaoEST.Text + '",'+
    '"ativa": 1,'+                                    //Forçando ser Planta principal
    '"filial": 1,'+                                   //Forçando estar dentro das Filiais
    '"emailc": "' + mEmailC.Text + '",'+
    '"nfe_email00": "' + mEmailNFe.Text + '",'+
    '"contatop": "' + mContatoP.Text + '",'+
    '"cep": "' + mCEP.Text + '",'+
    '"complemento": "' + mComplemento.Text + '",'+
    '"endereco": "' + mLogra.Text + '",'+
    '"ibge": "' + mIBGE.Text + '",'+
    '"nfe_regimefiscal": ' + mRegime.Text + ','+
    '"estado": "' + mEstado.Text + '",'+
    '"tronco": "' + mTRONCO.Text + '"}';
end;

procedure TuPlanta.CriterioKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
        if (Key = VK_F2) or (Key = VK_F3) or (Key= VK_RETURN) then Begin
        //  Pesquisa Municípios

            btnPesquisarClick(Self);
        End;
end;

procedure TuPlanta.mRazaoKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    if Key = VK_TAB then begin
        mTRONCO.SetFocus;
        mTRONCO.SelectAll;
    end;
end;

procedure TuPlanta.mCNPJKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    if Key = VK_F3 then begin

        mRazao.SetFocus;
        mRazao.SelectAll;
    end;
end;

procedure TuPlanta.mMarcaKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
    //Não funciona os eventos de tecla ! (13/01/2025)
    //(Key = VK_TAB) or
    if (Key = VK_F3) then begin
        mCNPJ.SetFocus;
        mCNPJ.SelectAll;
    End;
end;

procedure TuPlanta.Nav01Post(Sender: TObject);
begin
    AfterEdit;    //Monta JSON

    if (mIdPess.Text <> '') and (WebClientDS.State  in [dsedit]) then
    begin


        //if WebClientDS.State  in [dsedit] then
        //begin

        //end;

        //upProdutos.URL := 'http://localhost:8083/api/produtos/' + mIdProd.Text;
        upPlanta.URL := FrmMain.BaseURL + 'pessoafj/' + mIdPess.Text;
        upPlanta.Command := httpPUT;
        upPlanta.Headers.Clear;
        upPlanta.Headers.AddPair('Content-Type','application/json');
        upPlanta.Headers.AddPair('Accept','application/json, text/plain, */*');
        upPlanta.PostData := xJSON;
        upPlanta.Execute();
    end;

    if (WebClientDS.State  in [dsinsert]) then
    begin

        //upPlanta.URL := 'http://localhost:8083/api/produtos';
        upPlanta.URL := FrmMain.BaseURL + 'pessoafj';

        upPlanta.Command := httpPOST;
        upPlanta.Headers.Clear;
        upPlanta.Headers.AddPair('Content-Type','application/json');
        upPlanta.Headers.AddPair('Accept','application/json, text/plain, */*');
        upPlanta.PostData := xJSON;
        upPlanta.Execute();
    end;
end;

procedure TuPlanta.btnExcluirClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

            try
              //Cabeçalho do HTML
              //upPlanta.URL := 'http://localhost:8083/api/produtos/deletar/' + mIdProd.Text;
              upPlanta.URL := FrmMain.BaseURL + 'pessoafj/deletar/' + mIdPess.Text;
              upPlanta.Command := httpDELETE;
              upPlanta.Execute();
              WebClientDS.Delete;

            except on E: Exception do
              begin
                RS.Visible:= true;
                RS.Text:= 'Feedback Error: ['+E.ClassName+'] '+E.Message;
              end;
            end;


          end;
    end;


begin
  if  mIdPess.Text <> '' then
  begin
      Msg01.ShowDialog('Deseja excluir a Empresa (' + mMarca.Text + ') ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);
  end;


end;

procedure TuPlanta.btnPesquisarClick(Sender: TObject);
var
  xURL: widestring;
  xOffset,
  Interm, xCampo: string;
begin
    //Exemplo interessante de autorização
    //https://api.github.com/user/repos?per_page=50  **


    try
      WebConn.Active:= false;

      //BaseURL := 'pessoafj?ativa=1';
      xURL:= FrmMain.BaseURL + 'pessoafj?ativa=1';

      //MousePointer.Cursor := -11;
      WebConn.URI := xURL;
      WebConn.Active:= true;
      RS.Text := WebConn.URI;
    finally
      //Screen.Cursor := 0;
    end;


end;

procedure TuPlanta.CloseDataClick(Sender: TObject);
begin
    WebConn.Active      := false;
end;

procedure TuPlanta.cRegimeFiscalClick(Sender: TObject);
begin
    if (mIdPess.Text <> '') and (WebClientDS.State  in [dsedit]) then
    begin
    //Estando em Edição então aaltera
        case cRegimeFiscal.ItemIndex of
            0:begin
                WebClientDS.FieldByName('nfe_regimefiscal').AsInteger:= 1;
                //mRegime.Text:= '1';
            end;
            1:begin
                //mRegime.Text:= '2';
                WebClientDS.FieldByName('nfe_regimefiscal').AsInteger:= 2;
            end;
            2:begin
                //mRegime.Text:= '3';
                WebClientDS.FieldByName('nfe_regimefiscal').AsInteger:= 3;
            end;
            3:begin
                //mRegime.Text:= '4';
                WebClientDS.FieldByName('nfe_regimefiscal').AsInteger:= 4;
            end;
        end;
    end else begin
    //Não estando em edição volta copm os dados do banco (O Combo não é de banco de dados) por isso esta rotina
        if mRegime.Text = '1' then begin
            cRegimeFiscal.ItemIndex:= 0;
        end;
        if mRegime.Text = '2' then begin
            cRegimeFiscal.ItemIndex:= 1;
        end;
        if mRegime.Text = '3' then begin
            cRegimeFiscal.ItemIndex:= 2;
        end;
        if mRegime.Text = '4' then begin
            cRegimeFiscal.ItemIndex:= 3;
        end;
    end;
end;

procedure TuPlanta.WebClientDSBeforePost(DataSet: TDataSet);
begin
//001- Validação dos campos
    {if mIdMain.Text = '' then
    begin
        ShowMessage('Quantidade de etiquetas indefinida !');
        exit;
    end;}
//001- Validação dos campos




  { not fLoading then
  begin
    //Regras de validação aqui
    //    fRESTClient: IMVCRESTClient;
    Screen.Cursor:= -11;
    if memCategEQP.State = dsInsert then
      Res := fRESTClient.DataSetInsert('/api/categeqp', memCategEQP)
    else
      Res := fRESTClient.DataSetUpdate('/api/categeqp', memCategEQPidcateqp.AsString, memcategeqp);
    if not(Res.StatusCode in [200, 201]) then
    begin
      //DataSet.Refresh;    //Sem o Refresh o mesmo não muda de posição
      ShowError(Res);
      Abort;
    end
    else
    begin
      DataSet.Refresh;
      Screen.Cursor:= 0;
    end;
  end;}

end;

procedure TuPlanta.WebDTSDataChange(Sender: TObject; Field: TField);
begin
    if (mIdPess.Text <> '') and not(WebClientDS.State  in [dsedit]) then
    begin
      if mRegime.Text = '1' then begin
          cRegimeFiscal.ItemIndex:= 0;
      end;
      if mRegime.Text = '2' then begin
          cRegimeFiscal.ItemIndex:= 1;
      end;
      if mRegime.Text = '3' then begin
          cRegimeFiscal.ItemIndex:= 2;
      end;
      if mRegime.Text = '4' then begin
          cRegimeFiscal.ItemIndex:= 3;
      end;
    end;
end;

procedure TuPlanta.WebFormHashChange(Sender: TObject; oldURL, newURL: string);
begin
  if window.location.hash = '' then
    Close;
end;


procedure TuPlanta.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  CloseData := TButton.Create(Self);
  RS := TEdit.Create(Self);
  btnPesquisar := TBitBtn.Create(Self);
  Msg01 := TMessageDlg.Create(Self);
  btnExcluir := TBitBtn.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  mCNPJ := TDBEdit.Create(Self);
  mMarca := TDBEdit.Create(Self);
  mCEP := TDBEdit.Create(Self);
  mComplemento := TDBEdit.Create(Self);
  mIdPess := TDBEdit.Create(Self);
  mRazao := TDBEdit.Create(Self);
  mLogra := TDBEdit.Create(Self);
  Nav01 := TDBNavigator.Create(Self);
  mTRONCO := TDBEdit.Create(Self);
  mEmailC := TDBEdit.Create(Self);
  mEmailNFe := TDBEdit.Create(Self);
  mInscricaoEST := TDBEdit.Create(Self);
  mCidade := TDBEdit.Create(Self);
  mEstado := TDBEdit.Create(Self);
  cad_lMUNI := TBitBtn.Create(Self);
  mAtiva := TDBEdit.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  mIBGE := TDBEdit.Create(Self);
  mContatoP := TDBEdit.Create(Self);
  mRegime := TDBEdit.Create(Self);
  cRegimeFiscal := TComboBox.Create(Self);
  WebConn := TClientConnection.Create(Self);
  WebDTS := TDataSource.Create(Self);
  upPlanta := THttpRequest.Create(Self);
  WebClientDS := TClientDataSet.Create(Self);
  WebClientDSidpess := TIntegerField.Create(Self);
  WebClientDSmarca := TStringField.Create(Self);
  WebClientDSrazao := TStringField.Create(Self);
  WebClientDSidgrupo := TIntegerField.Create(Self);
  WebClientDScnpj := TStringField.Create(Self);
  WebClientDScnpj_serie := TIntegerField.Create(Self);
  WebClientDSinscricaoest := TStringField.Create(Self);
  WebClientDSendereco := TStringField.Create(Self);
  WebClientDStronco := TStringField.Create(Self);
  WebClientDSstatus := TStringField.Create(Self);
  WebClientDSbairro := TStringField.Create(Self);
  WebClientDScidade := TStringField.Create(Self);
  WebClientDScep := TStringField.Create(Self);
  WebClientDSestado := TStringField.Create(Self);
  WebClientDScomplemento := TStringField.Create(Self);
  WebClientDSativa := TBooleanField.Create(Self);
  WebClientDSfilial := TBooleanField.Create(Self);
  WebClientDSemailc := TStringField.Create(Self);
  WebClientDSnfe_email00 := TStringField.Create(Self);
  WebClientDScontatop := TStringField.Create(Self);
  WebClientDSsim_cpf := TBooleanField.Create(Self);
  WebClientDSbacen := TIntegerField.Create(Self);
  WebClientDSidcchain := TIntegerField.Create(Self);
  WebClientDSidseg := TIntegerField.Create(Self);
  WebClientDSdatacad := TDateTimeField.Create(Self);
  WebClientDSibge := TStringField.Create(Self);
  WebClientDSnfe_regimefiscal := TIntegerField.Create(Self);
  WebClientDSequalcmcarvalho := TBooleanField.Create(Self);
  WebClientDSok_cliente := TBooleanField.Create(Self);
  WebClientDSok_forne := TBooleanField.Create(Self);
  WebClientDSok_transp := TBooleanField.Create(Self);
  WebClientDSok_repres := TBooleanField.Create(Self);
  WebClientDSok_vend := TBooleanField.Create(Self);
  WebClientDSok_compra := TBooleanField.Create(Self);
  WebClientDSok_montadora := TBooleanField.Create(Self);
  WebClientDSok_func := TBooleanField.Create(Self);
  WebClientDSok_ppilha := TIntegerField.Create(Self);
  WebClientDSinscricaom := TStringField.Create(Self);
  WebClientDSinscricaoccm := TStringField.Create(Self);
  WebClientDSnosso_num := TStringField.Create(Self);
  WebClientDSduns_number := TStringField.Create(Self);
  WebClientDScpostal := TStringField.Create(Self);
  WebClientDSendcob := TStringField.Create(Self);
  WebClientDSmunicob := TStringField.Create(Self);
  WebClientDScepcob := TStringField.Create(Self);
  WebClientDSbaicob := TStringField.Create(Self);
  WebClientDSufcob := TStringField.Create(Self);
  WebClientDSendent := TStringField.Create(Self);
  WebClientDScepent := TStringField.Create(Self);
  WebClientDSbaient := TStringField.Create(Self);
  WebClientDSufent := TStringField.Create(Self);
  WebClientDScident := TStringField.Create(Self);
  WebClientDStipopj := TIntegerField.Create(Self);
  WebClientDStipovenda := TIntegerField.Create(Self);
  WebClientDSobspj := TStringField.Create(Self);
  WebClientDSnfserieedi := TStringField.Create(Self);
  WebClientDSbvqi := TBooleanField.Create(Self);
  WebClientDSconfere_carga := TBooleanField.Create(Self);
  WebClientDSnato := TIntegerField.Create(Self);
  WebClientDSregimefiscal := TStringField.Create(Self);
  WebClientDScontadeb_cm := TIntegerField.Create(Self);
  WebClientDScontacred_cs := TIntegerField.Create(Self);
  WebClientDScontacred_vp := TIntegerField.Create(Self);
  WebClientDScancelado := TBooleanField.Create(Self);
  WebClientDSfornecabc := TStringField.Create(Self);
  WebClientDSclienteabc := TStringField.Create(Self);
  WebClientDSidbco := TIntegerField.Create(Self);
  WebClientDSidtpgto := TIntegerField.Create(Self);
  WebClientDSidtpgtocc := TIntegerField.Create(Self);
  WebClientDSidtpgtocd := TIntegerField.Create(Self);
  WebClientDSpedeae5 := TIntegerField.Create(Self);
  WebClientDSpedeae9 := TIntegerField.Create(Self);
  WebClientDSidformav := TIntegerField.Create(Self);
  WebClientDSidformac := TIntegerField.Create(Self);
  WebClientDSvdm4 := TIntegerField.Create(Self);
  WebClientDSqdm4 := TIntegerField.Create(Self);
  WebClientDSfreq4m := TIntegerField.Create(Self);
  WebClientDSqpmatr := TIntegerField.Create(Self);
  WebClientDSqpm01 := TIntegerField.Create(Self);
  WebClientDSqpm02 := TIntegerField.Create(Self);
  WebClientDSqpm03 := TIntegerField.Create(Self);
  WebClientDSqpm04 := TIntegerField.Create(Self);
  WebClientDSqpm05 := TIntegerField.Create(Self);
  WebClientDSqpm06 := TIntegerField.Create(Self);
  WebClientDSqpm07 := TIntegerField.Create(Self);
  WebClientDSqpm08 := TIntegerField.Create(Self);
  WebClientDSqpm09 := TIntegerField.Create(Self);
  WebClientDSqpm10 := TIntegerField.Create(Self);
  WebClientDSqpm11 := TIntegerField.Create(Self);
  WebClientDSqpm12 := TIntegerField.Create(Self);
  WebClientDSvps11 := TIntegerField.Create(Self);
  WebClientDSvps12 := TIntegerField.Create(Self);
  WebClientDSvps13 := TIntegerField.Create(Self);
  WebClientDSvps14 := TIntegerField.Create(Self);
  WebClientDSvps15 := TIntegerField.Create(Self);
  WebClientDSvpmatr := TIntegerField.Create(Self);
  WebClientDSvpm01 := TIntegerField.Create(Self);
  WebClientDSvpm02 := TIntegerField.Create(Self);
  WebClientDSvpm03 := TIntegerField.Create(Self);
  WebClientDSvpm04 := TIntegerField.Create(Self);
  WebClientDSvpm05 := TIntegerField.Create(Self);
  WebClientDSvpm06 := TIntegerField.Create(Self);
  WebClientDSvpm07 := TIntegerField.Create(Self);
  WebClientDSvpm08 := TIntegerField.Create(Self);
  WebClientDSvpm09 := TIntegerField.Create(Self);
  WebClientDSvpm10 := TIntegerField.Create(Self);
  WebClientDSvpm11 := TIntegerField.Create(Self);
  WebClientDSvpm12 := TIntegerField.Create(Self);
  WebClientDSvpmatrliq := TIntegerField.Create(Self);
  WebClientDSvpm01liq := TIntegerField.Create(Self);
  WebClientDSvpm02liq := TIntegerField.Create(Self);
  WebClientDSvpm03liq := TIntegerField.Create(Self);
  WebClientDSvpm04liq := TIntegerField.Create(Self);
  WebClientDSvpm05liq := TIntegerField.Create(Self);
  WebClientDSvpm06liq := TIntegerField.Create(Self);
  WebClientDSvpm07liq := TIntegerField.Create(Self);
  WebClientDSvpm08liq := TIntegerField.Create(Self);
  WebClientDSvpm09liq := TIntegerField.Create(Self);
  WebClientDSvpm10liq := TIntegerField.Create(Self);
  WebClientDSvpm11liq := TIntegerField.Create(Self);
  WebClientDSvpm12liq := TIntegerField.Create(Self);
  WebClientDSqvano := TIntegerField.Create(Self);
  WebClientDSpqvano := TIntegerField.Create(Self);
  WebClientDSfone := TStringField.Create(Self);
  WebClientDSfax := TStringField.Create(Self);
  WebClientDSemaile := TStringField.Create(Self);
  WebClientDSemailct := TStringField.Create(Self);
  WebClientDStipo_qc := TIntegerField.Create(Self);
  WebClientDSicm_compra := TIntegerField.Create(Self);
  WebClientDSrespcad := TStringField.Create(Self);
  WebClientDSciclo_numped := TIntegerField.Create(Self);
  WebClientDScode_transp := TIntegerField.Create(Self);
  WebClientDScodev_cfop := TIntegerField.Create(Self);
  WebClientDScodec_cfop := TIntegerField.Create(Self);
  WebClientDSnfe_assunto := TStringField.Create(Self);
  WebClientDSnfe_textoemail := TStringField.Create(Self);
  WebClientDScontatom := TStringField.Create(Self);
  WebClientDSsim_mala := TBooleanField.Create(Self);
  WebClientDSnfe_amp := TIntegerField.Create(Self);
  WebClientDSrestr_fatmsg00 := TStringField.Create(Self);
  WebClientDSrestr_fatflag00 := TIntegerField.Create(Self);
  WebClientDSinscritoie := TBooleanField.Create(Self);
  WebClientDSmkp := TIntegerField.Create(Self);
  WebClientDSsuframa := TStringField.Create(Self);
  WebClientDSsipi_pmp := TIntegerField.Create(Self);
  WebClientDSidvendedor := TIntegerField.Create(Self);
  WebClientDScomissao := TIntegerField.Create(Self);
  WebClientDSbaixarnfe_filhos := TIntegerField.Create(Self);
  WebClientDSnfe_tpfrete := TIntegerField.Create(Self);
  WebClientDSp_pis := TIntegerField.Create(Self);
  WebClientDSp_cofins := TIntegerField.Create(Self);
  WebClientDSp_iss := TIntegerField.Create(Self);
  WebClientDSp_inss := TIntegerField.Create(Self);
  WebClientDSp_csl := TIntegerField.Create(Self);
  WebClientDSp_ir := TIntegerField.Create(Self);
  WebClientDSp_pispasep := TIntegerField.Create(Self);
  WebClientDSidbcod := TIntegerField.Create(Self);
  WebClientDScredita_pis := TBooleanField.Create(Self);
  WebClientDScredita_cofins := TBooleanField.Create(Self);
  WebClientDScreditap_pis := TFloatField.Create(Self);
  WebClientDScreditap_cofins := TFloatField.Create(Self);
  WebClientDStravap := TIntegerField.Create(Self);
  WebClientDSexnitemped := TIntegerField.Create(Self);
  WebClientDStnitemped := TIntegerField.Create(Self);
  WebClientDSpdesc := TIntegerField.Create(Self);
  WebClientDSsim_cfinal := TBooleanField.Create(Self);
  WebClientDSidcnt := TIntegerField.Create(Self);
  WebClientDSautoexecute := TIntegerField.Create(Self);
  WebClientDSsim_deljit := TIntegerField.Create(Self);
  WebClientDSsim_delfor := TIntegerField.Create(Self);
  WebClientDSsim_excel := TIntegerField.Create(Self);
  WebClientDSsim_manual := TIntegerField.Create(Self);
  WebClientDSidpedf := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  CloseData.BeforeLoadDFMValues;
  RS.BeforeLoadDFMValues;
  btnPesquisar.BeforeLoadDFMValues;
  Msg01.BeforeLoadDFMValues;
  btnExcluir.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  mCNPJ.BeforeLoadDFMValues;
  mMarca.BeforeLoadDFMValues;
  mCEP.BeforeLoadDFMValues;
  mComplemento.BeforeLoadDFMValues;
  mIdPess.BeforeLoadDFMValues;
  mRazao.BeforeLoadDFMValues;
  mLogra.BeforeLoadDFMValues;
  Nav01.BeforeLoadDFMValues;
  mTRONCO.BeforeLoadDFMValues;
  mEmailC.BeforeLoadDFMValues;
  mEmailNFe.BeforeLoadDFMValues;
  mInscricaoEST.BeforeLoadDFMValues;
  mCidade.BeforeLoadDFMValues;
  mEstado.BeforeLoadDFMValues;
  cad_lMUNI.BeforeLoadDFMValues;
  mAtiva.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  mIBGE.BeforeLoadDFMValues;
  mContatoP.BeforeLoadDFMValues;
  mRegime.BeforeLoadDFMValues;
  cRegimeFiscal.BeforeLoadDFMValues;
  WebConn.BeforeLoadDFMValues;
  WebDTS.BeforeLoadDFMValues;
  upPlanta.BeforeLoadDFMValues;
  WebClientDS.BeforeLoadDFMValues;
  WebClientDSidpess.BeforeLoadDFMValues;
  WebClientDSmarca.BeforeLoadDFMValues;
  WebClientDSrazao.BeforeLoadDFMValues;
  WebClientDSidgrupo.BeforeLoadDFMValues;
  WebClientDScnpj.BeforeLoadDFMValues;
  WebClientDScnpj_serie.BeforeLoadDFMValues;
  WebClientDSinscricaoest.BeforeLoadDFMValues;
  WebClientDSendereco.BeforeLoadDFMValues;
  WebClientDStronco.BeforeLoadDFMValues;
  WebClientDSstatus.BeforeLoadDFMValues;
  WebClientDSbairro.BeforeLoadDFMValues;
  WebClientDScidade.BeforeLoadDFMValues;
  WebClientDScep.BeforeLoadDFMValues;
  WebClientDSestado.BeforeLoadDFMValues;
  WebClientDScomplemento.BeforeLoadDFMValues;
  WebClientDSativa.BeforeLoadDFMValues;
  WebClientDSfilial.BeforeLoadDFMValues;
  WebClientDSemailc.BeforeLoadDFMValues;
  WebClientDSnfe_email00.BeforeLoadDFMValues;
  WebClientDScontatop.BeforeLoadDFMValues;
  WebClientDSsim_cpf.BeforeLoadDFMValues;
  WebClientDSbacen.BeforeLoadDFMValues;
  WebClientDSidcchain.BeforeLoadDFMValues;
  WebClientDSidseg.BeforeLoadDFMValues;
  WebClientDSdatacad.BeforeLoadDFMValues;
  WebClientDSibge.BeforeLoadDFMValues;
  WebClientDSnfe_regimefiscal.BeforeLoadDFMValues;
  WebClientDSequalcmcarvalho.BeforeLoadDFMValues;
  WebClientDSok_cliente.BeforeLoadDFMValues;
  WebClientDSok_forne.BeforeLoadDFMValues;
  WebClientDSok_transp.BeforeLoadDFMValues;
  WebClientDSok_repres.BeforeLoadDFMValues;
  WebClientDSok_vend.BeforeLoadDFMValues;
  WebClientDSok_compra.BeforeLoadDFMValues;
  WebClientDSok_montadora.BeforeLoadDFMValues;
  WebClientDSok_func.BeforeLoadDFMValues;
  WebClientDSok_ppilha.BeforeLoadDFMValues;
  WebClientDSinscricaom.BeforeLoadDFMValues;
  WebClientDSinscricaoccm.BeforeLoadDFMValues;
  WebClientDSnosso_num.BeforeLoadDFMValues;
  WebClientDSduns_number.BeforeLoadDFMValues;
  WebClientDScpostal.BeforeLoadDFMValues;
  WebClientDSendcob.BeforeLoadDFMValues;
  WebClientDSmunicob.BeforeLoadDFMValues;
  WebClientDScepcob.BeforeLoadDFMValues;
  WebClientDSbaicob.BeforeLoadDFMValues;
  WebClientDSufcob.BeforeLoadDFMValues;
  WebClientDSendent.BeforeLoadDFMValues;
  WebClientDScepent.BeforeLoadDFMValues;
  WebClientDSbaient.BeforeLoadDFMValues;
  WebClientDSufent.BeforeLoadDFMValues;
  WebClientDScident.BeforeLoadDFMValues;
  WebClientDStipopj.BeforeLoadDFMValues;
  WebClientDStipovenda.BeforeLoadDFMValues;
  WebClientDSobspj.BeforeLoadDFMValues;
  WebClientDSnfserieedi.BeforeLoadDFMValues;
  WebClientDSbvqi.BeforeLoadDFMValues;
  WebClientDSconfere_carga.BeforeLoadDFMValues;
  WebClientDSnato.BeforeLoadDFMValues;
  WebClientDSregimefiscal.BeforeLoadDFMValues;
  WebClientDScontadeb_cm.BeforeLoadDFMValues;
  WebClientDScontacred_cs.BeforeLoadDFMValues;
  WebClientDScontacred_vp.BeforeLoadDFMValues;
  WebClientDScancelado.BeforeLoadDFMValues;
  WebClientDSfornecabc.BeforeLoadDFMValues;
  WebClientDSclienteabc.BeforeLoadDFMValues;
  WebClientDSidbco.BeforeLoadDFMValues;
  WebClientDSidtpgto.BeforeLoadDFMValues;
  WebClientDSidtpgtocc.BeforeLoadDFMValues;
  WebClientDSidtpgtocd.BeforeLoadDFMValues;
  WebClientDSpedeae5.BeforeLoadDFMValues;
  WebClientDSpedeae9.BeforeLoadDFMValues;
  WebClientDSidformav.BeforeLoadDFMValues;
  WebClientDSidformac.BeforeLoadDFMValues;
  WebClientDSvdm4.BeforeLoadDFMValues;
  WebClientDSqdm4.BeforeLoadDFMValues;
  WebClientDSfreq4m.BeforeLoadDFMValues;
  WebClientDSqpmatr.BeforeLoadDFMValues;
  WebClientDSqpm01.BeforeLoadDFMValues;
  WebClientDSqpm02.BeforeLoadDFMValues;
  WebClientDSqpm03.BeforeLoadDFMValues;
  WebClientDSqpm04.BeforeLoadDFMValues;
  WebClientDSqpm05.BeforeLoadDFMValues;
  WebClientDSqpm06.BeforeLoadDFMValues;
  WebClientDSqpm07.BeforeLoadDFMValues;
  WebClientDSqpm08.BeforeLoadDFMValues;
  WebClientDSqpm09.BeforeLoadDFMValues;
  WebClientDSqpm10.BeforeLoadDFMValues;
  WebClientDSqpm11.BeforeLoadDFMValues;
  WebClientDSqpm12.BeforeLoadDFMValues;
  WebClientDSvps11.BeforeLoadDFMValues;
  WebClientDSvps12.BeforeLoadDFMValues;
  WebClientDSvps13.BeforeLoadDFMValues;
  WebClientDSvps14.BeforeLoadDFMValues;
  WebClientDSvps15.BeforeLoadDFMValues;
  WebClientDSvpmatr.BeforeLoadDFMValues;
  WebClientDSvpm01.BeforeLoadDFMValues;
  WebClientDSvpm02.BeforeLoadDFMValues;
  WebClientDSvpm03.BeforeLoadDFMValues;
  WebClientDSvpm04.BeforeLoadDFMValues;
  WebClientDSvpm05.BeforeLoadDFMValues;
  WebClientDSvpm06.BeforeLoadDFMValues;
  WebClientDSvpm07.BeforeLoadDFMValues;
  WebClientDSvpm08.BeforeLoadDFMValues;
  WebClientDSvpm09.BeforeLoadDFMValues;
  WebClientDSvpm10.BeforeLoadDFMValues;
  WebClientDSvpm11.BeforeLoadDFMValues;
  WebClientDSvpm12.BeforeLoadDFMValues;
  WebClientDSvpmatrliq.BeforeLoadDFMValues;
  WebClientDSvpm01liq.BeforeLoadDFMValues;
  WebClientDSvpm02liq.BeforeLoadDFMValues;
  WebClientDSvpm03liq.BeforeLoadDFMValues;
  WebClientDSvpm04liq.BeforeLoadDFMValues;
  WebClientDSvpm05liq.BeforeLoadDFMValues;
  WebClientDSvpm06liq.BeforeLoadDFMValues;
  WebClientDSvpm07liq.BeforeLoadDFMValues;
  WebClientDSvpm08liq.BeforeLoadDFMValues;
  WebClientDSvpm09liq.BeforeLoadDFMValues;
  WebClientDSvpm10liq.BeforeLoadDFMValues;
  WebClientDSvpm11liq.BeforeLoadDFMValues;
  WebClientDSvpm12liq.BeforeLoadDFMValues;
  WebClientDSqvano.BeforeLoadDFMValues;
  WebClientDSpqvano.BeforeLoadDFMValues;
  WebClientDSfone.BeforeLoadDFMValues;
  WebClientDSfax.BeforeLoadDFMValues;
  WebClientDSemaile.BeforeLoadDFMValues;
  WebClientDSemailct.BeforeLoadDFMValues;
  WebClientDStipo_qc.BeforeLoadDFMValues;
  WebClientDSicm_compra.BeforeLoadDFMValues;
  WebClientDSrespcad.BeforeLoadDFMValues;
  WebClientDSciclo_numped.BeforeLoadDFMValues;
  WebClientDScode_transp.BeforeLoadDFMValues;
  WebClientDScodev_cfop.BeforeLoadDFMValues;
  WebClientDScodec_cfop.BeforeLoadDFMValues;
  WebClientDSnfe_assunto.BeforeLoadDFMValues;
  WebClientDSnfe_textoemail.BeforeLoadDFMValues;
  WebClientDScontatom.BeforeLoadDFMValues;
  WebClientDSsim_mala.BeforeLoadDFMValues;
  WebClientDSnfe_amp.BeforeLoadDFMValues;
  WebClientDSrestr_fatmsg00.BeforeLoadDFMValues;
  WebClientDSrestr_fatflag00.BeforeLoadDFMValues;
  WebClientDSinscritoie.BeforeLoadDFMValues;
  WebClientDSmkp.BeforeLoadDFMValues;
  WebClientDSsuframa.BeforeLoadDFMValues;
  WebClientDSsipi_pmp.BeforeLoadDFMValues;
  WebClientDSidvendedor.BeforeLoadDFMValues;
  WebClientDScomissao.BeforeLoadDFMValues;
  WebClientDSbaixarnfe_filhos.BeforeLoadDFMValues;
  WebClientDSnfe_tpfrete.BeforeLoadDFMValues;
  WebClientDSp_pis.BeforeLoadDFMValues;
  WebClientDSp_cofins.BeforeLoadDFMValues;
  WebClientDSp_iss.BeforeLoadDFMValues;
  WebClientDSp_inss.BeforeLoadDFMValues;
  WebClientDSp_csl.BeforeLoadDFMValues;
  WebClientDSp_ir.BeforeLoadDFMValues;
  WebClientDSp_pispasep.BeforeLoadDFMValues;
  WebClientDSidbcod.BeforeLoadDFMValues;
  WebClientDScredita_pis.BeforeLoadDFMValues;
  WebClientDScredita_cofins.BeforeLoadDFMValues;
  WebClientDScreditap_pis.BeforeLoadDFMValues;
  WebClientDScreditap_cofins.BeforeLoadDFMValues;
  WebClientDStravap.BeforeLoadDFMValues;
  WebClientDSexnitemped.BeforeLoadDFMValues;
  WebClientDStnitemped.BeforeLoadDFMValues;
  WebClientDSpdesc.BeforeLoadDFMValues;
  WebClientDSsim_cfinal.BeforeLoadDFMValues;
  WebClientDSidcnt.BeforeLoadDFMValues;
  WebClientDSautoexecute.BeforeLoadDFMValues;
  WebClientDSsim_deljit.BeforeLoadDFMValues;
  WebClientDSsim_delfor.BeforeLoadDFMValues;
  WebClientDSsim_excel.BeforeLoadDFMValues;
  WebClientDSsim_manual.BeforeLoadDFMValues;
  WebClientDSidpedf.BeforeLoadDFMValues;
  try
    Name := 'uPlanta';
    Width := 1100;
    Height := 554;
    Color := 16711422;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    Shadow := False;
    Visible := True;
    SetEvent(Self, 'OnHashChange', 'WebFormHashChange');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1100;
    WebPanel1.Height := 113;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := clWindow;
    WebPanel1.ChildOrder := 24;
    WebPanel1.Color := clWindow;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 17;
    WebLabel1.Width := 266;
    WebLabel1.Height := 39;
    WebLabel1.Caption := 'Dados da Empresa';
    WebLabel1.Color := 16711422;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -32;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    CloseData.SetParentComponent(WebPanel1);
    CloseData.Name := 'CloseData';
    CloseData.Left := 575;
    CloseData.Top := 33;
    CloseData.Width := 81;
    CloseData.Height := 25;
    CloseData.Caption := 'Close URLs';
    CloseData.ChildOrder := 6;
    CloseData.HeightPercent := 100.000000000000000000;
    CloseData.Visible := False;
    CloseData.WidthPercent := 100.000000000000000000;
    SetEvent(CloseData, Self, 'OnClick', 'CloseDataClick');
    RS.SetParentComponent(WebPanel1);
    RS.Name := 'RS';
    RS.Left := 3;
    RS.Top := 3;
    RS.Width := 653;
    RS.Height := 24;
    RS.ChildOrder := 6;
    RS.HeightPercent := 100.000000000000000000;
    RS.Required := True;
    RS.TabOrder := 1;
    RS.Visible := False;
    RS.WidthPercent := 100.000000000000000000;
    btnPesquisar.SetParentComponent(WebPanel1);
    btnPesquisar.Name := 'btnPesquisar';
    btnPesquisar.Left := 64;
    btnPesquisar.Top := 82;
    btnPesquisar.Width := 106;
    btnPesquisar.Height := 25;
    btnPesquisar.Caption := 'Pesquisar';
    btnPesquisar.Color := clSkyBlue;
    btnPesquisar.ElementClassName := 'btn btn-light';
    btnPesquisar.ElementFont := efCSS;
    btnPesquisar.Font.Charset := ANSI_CHARSET;
    btnPesquisar.Font.Color := clBlack;
    btnPesquisar.Font.Height := -13;
    btnPesquisar.Font.Name := 'Roboto';
    btnPesquisar.Font.Style := [];
    btnPesquisar.Glyph.LoadFromFile('Planta.WebPanel1.btnPesquisar.Glyph.png');
    btnPesquisar.HeightStyle := ssAuto;
    btnPesquisar.HeightPercent := 100.000000000000000000;
    btnPesquisar.ParentFont := False;
    btnPesquisar.TabOrder := 3;
    btnPesquisar.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisar, Self, 'OnClick', 'btnPesquisarClick');
    Msg01.SetParentComponent(WebPanel1);
    Msg01.Name := 'Msg01';
    Msg01.Left := 319;
    Msg01.Top := 55;
    Msg01.Width := 24;
    Msg01.Height := 24;
    Msg01.Buttons := [];
    Msg01.Opacity := 0.200000000000000000;
    btnExcluir.SetParentComponent(WebPanel1);
    btnExcluir.Name := 'btnExcluir';
    btnExcluir.Left := 599;
    btnExcluir.Top := 82;
    btnExcluir.Width := 106;
    btnExcluir.Height := 25;
    btnExcluir.Caption := 'Excluir';
    btnExcluir.Color := 13290239;
    btnExcluir.ElementClassName := 'btn btn-light';
    btnExcluir.ElementFont := efCSS;
    btnExcluir.Font.Charset := ANSI_CHARSET;
    btnExcluir.Font.Color := clBlack;
    btnExcluir.Font.Height := -13;
    btnExcluir.Font.Name := 'Roboto';
    btnExcluir.Font.Style := [];
    btnExcluir.Glyph.LoadFromFile('Planta.WebPanel1.btnExcluir.Glyph.png');
    btnExcluir.HeightStyle := ssAuto;
    btnExcluir.HeightPercent := 100.000000000000000000;
    btnExcluir.ParentFont := False;
    btnExcluir.TabOrder := 3;
    btnExcluir.WidthPercent := 100.000000000000000000;
    SetEvent(btnExcluir, Self, 'OnClick', 'btnExcluirClick');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 113;
    WebPanel2.Width := 1100;
    WebPanel2.Height := 441;
    WebPanel2.Align := alClient;
    WebPanel2.BorderColor := clWindow;
    WebPanel2.ChildOrder := 13;
    WebPanel2.Color := clWindow;
    WebPanel2.TabOrder := 1;
    WebLabel8.SetParentComponent(WebPanel2);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 63;
    WebLabel8.Top := 28;
    WebLabel8.Width := 53;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Fantasia:';
    WebLabel8.Color := 16711422;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel2);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 278;
    WebLabel7.Top := 28;
    WebLabel7.Width := 68;
    WebLabel7.Height := 16;
    WebLabel7.Caption := 'CNPJ / CPF:';
    WebLabel7.Color := 16711422;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 63;
    WebLabel6.Top := 228;
    WebLabel6.Width := 95;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Email comercial:';
    WebLabel6.Color := 16711422;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 63;
    WebLabel5.Top := 128;
    WebLabel5.Width := 39;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'C.E.P.:';
    WebLabel5.Color := 16711422;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 63;
    WebLabel2.Top := 178;
    WebLabel2.Width := 84;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'Complemento:';
    WebLabel2.Color := 16711422;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 63;
    WebLabel9.Top := 78;
    WebLabel9.Width := 124;
    WebLabel9.Height := 16;
    WebLabel9.Caption := 'Raz'#227'o Social / Nome:';
    WebLabel9.Color := 16711422;
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel2);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 157;
    WebLabel10.Top := 128;
    WebLabel10.Width := 70;
    WebLabel10.Height := 16;
    WebLabel10.Caption := 'Logradouro:';
    WebLabel10.Color := 16711422;
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel2);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 605;
    WebLabel11.Top := 128;
    WebLabel11.Width := 50;
    WebLabel11.Height := 16;
    WebLabel11.Caption := 'N'#250'mero:';
    WebLabel11.Color := 16711422;
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel2);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 583;
    WebLabel12.Top := 28;
    WebLabel12.Width := 64;
    WebLabel12.Height := 16;
    WebLabel12.Caption := 'N'#186' Interno:';
    WebLabel12.Color := 16711422;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 378;
    WebLabel3.Top := 228;
    WebLabel3.Width := 62;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Email NFe:';
    WebLabel3.Color := 16711422;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.Visible := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 431;
    WebLabel4.Top := 28;
    WebLabel4.Width := 108;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Inscri'#231#227'o Estadual:';
    WebLabel4.Color := 16711422;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel2);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 378;
    WebLabel13.Top := 178;
    WebLabel13.Width := 58;
    WebLabel13.Height := 16;
    WebLabel13.Caption := 'Munic'#237'pio:';
    WebLabel13.Color := 16711422;
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel2);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 639;
    WebLabel14.Top := 178;
    WebLabel14.Width := 28;
    WebLabel14.Height := 16;
    WebLabel14.Caption := 'U.F.:';
    WebLabel14.Color := 16711422;
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel2);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 725;
    WebLabel15.Top := 28;
    WebLabel15.Width := 41;
    WebLabel15.Height := 16;
    WebLabel15.Caption := 'Status:';
    WebLabel15.Color := 16711422;
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.Visible := False;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel2);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 584;
    WebLabel16.Top := 78;
    WebLabel16.Width := 86;
    WebLabel16.Height := 16;
    WebLabel16.Caption := 'Data Cadastro:';
    WebLabel16.Color := 16711422;
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel2);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 725;
    WebLabel17.Top := 178;
    WebLabel17.Width := 31;
    WebLabel17.Height := 16;
    WebLabel17.Caption := 'IBGE:';
    WebLabel17.Color := 16711422;
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.Visible := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel2);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 63;
    WebLabel18.Top := 278;
    WebLabel18.Width := 101;
    WebLabel18.Height := 16;
    WebLabel18.Caption := 'Contato Principal:';
    WebLabel18.Color := 16711422;
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WebPanel2);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 488;
    WebLabel19.Top := 275;
    WebLabel19.Width := 84;
    WebLabel19.Height := 16;
    WebLabel19.Caption := 'Regime Fiscal:';
    WebLabel19.Color := 16711422;
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebPanel2);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 725;
    WebLabel20.Top := 278;
    WebLabel20.Width := 84;
    WebLabel20.Height := 16;
    WebLabel20.Caption := 'Regime Fiscal:';
    WebLabel20.Color := 16711422;
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.Visible := False;
    WebLabel20.WidthPercent := 100.000000000000000000;
    mCNPJ.SetParentComponent(WebPanel2);
    mCNPJ.Name := 'mCNPJ';
    mCNPJ.Left := 278;
    mCNPJ.Top := 45;
    mCNPJ.Width := 147;
    mCNPJ.Height := 24;
    mCNPJ.ChildOrder := 14;
    mCNPJ.EditType := weNumeric;
    mCNPJ.HeightPercent := 100.000000000000000000;
    mCNPJ.TabOrder := 1;
    mCNPJ.WidthPercent := 100.000000000000000000;
    SetEvent(mCNPJ, Self, 'OnKeyUp', 'mCNPJKeyUp');
    mCNPJ.DataField := 'cnpj';
    mCNPJ.DataSource := WebDTS;
    mMarca.SetParentComponent(WebPanel2);
    mMarca.Name := 'mMarca';
    mMarca.Left := 63;
    mMarca.Top := 45;
    mMarca.Width := 209;
    mMarca.Height := 24;
    mMarca.ChildOrder := 14;
    mMarca.HeightPercent := 100.000000000000000000;
    mMarca.WidthPercent := 100.000000000000000000;
    SetEvent(mMarca, Self, 'OnKeyUp', 'mMarcaKeyUp');
    mMarca.DataField := 'marca';
    mMarca.DataSource := WebDTS;
    mCEP.SetParentComponent(WebPanel2);
    mCEP.Name := 'mCEP';
    mCEP.Left := 63;
    mCEP.Top := 145;
    mCEP.Width := 88;
    mCEP.Height := 24;
    mCEP.TabStop := False;
    mCEP.ChildOrder := 14;
    mCEP.EditType := weFloat;
    mCEP.HeightPercent := 100.000000000000000000;
    mCEP.Required := True;
    mCEP.TabOrder := 6;
    mCEP.WidthPercent := 100.000000000000000000;
    mCEP.DataField := 'cep';
    mCEP.DataSource := WebDTS;
    mComplemento.SetParentComponent(WebPanel2);
    mComplemento.Name := 'mComplemento';
    mComplemento.Left := 63;
    mComplemento.Top := 195;
    mComplemento.Width := 309;
    mComplemento.Height := 24;
    mComplemento.ChildOrder := 14;
    mComplemento.HeightPercent := 100.000000000000000000;
    mComplemento.Required := True;
    mComplemento.TabOrder := 7;
    mComplemento.Text := 'mComplemento';
    mComplemento.WidthPercent := 100.000000000000000000;
    mComplemento.DataField := 'complemento';
    mComplemento.DataSource := WebDTS;
    mIdPess.SetParentComponent(WebPanel2);
    mIdPess.Name := 'mIdPess';
    mIdPess.Left := 583;
    mIdPess.Top := 45;
    mIdPess.Width := 122;
    mIdPess.Height := 24;
    mIdPess.ChildOrder := 14;
    mIdPess.Color := clKhaki;
    mIdPess.EditType := weFloat;
    mIdPess.HeightPercent := 100.000000000000000000;
    mIdPess.ReadOnly := True;
    mIdPess.TabOrder := 5;
    mIdPess.WidthPercent := 100.000000000000000000;
    mIdPess.DataField := 'idpess';
    mIdPess.DataSource := WebDTS;
    mRazao.SetParentComponent(WebPanel2);
    mRazao.Name := 'mRazao';
    mRazao.Left := 63;
    mRazao.Top := 95;
    mRazao.Width := 515;
    mRazao.Height := 24;
    mRazao.ChildOrder := 14;
    mRazao.HeightPercent := 100.000000000000000000;
    mRazao.TabOrder := 2;
    mRazao.Text := 'mRazao';
    mRazao.WidthPercent := 100.000000000000000000;
    SetEvent(mRazao, Self, 'OnKeyUp', 'mRazaoKeyUp');
    mRazao.DataField := 'razao';
    mRazao.DataSource := WebDTS;
    mLogra.SetParentComponent(WebPanel2);
    mLogra.Name := 'mLogra';
    mLogra.Left := 157;
    mLogra.Top := 145;
    mLogra.Width := 442;
    mLogra.Height := 24;
    mLogra.ChildOrder := 14;
    mLogra.HeightPercent := 100.000000000000000000;
    mLogra.TabOrder := 4;
    mLogra.Text := 'mLogra';
    mLogra.WidthPercent := 100.000000000000000000;
    mLogra.DataField := 'endereco';
    mLogra.DataSource := WebDTS;
    Nav01.SetParentComponent(WebPanel2);
    Nav01.Name := 'Nav01';
    Nav01.Left := 64;
    Nav01.Top := 348;
    Nav01.Width := 337;
    Nav01.Height := 25;
    Nav01.DataSource := WebDTS;
    Nav01.Hints.BeginUpdate;
    try
      Nav01.Hints.Clear;
      Nav01.Hints.Add('First');
      Nav01.Hints.Add('Prior');
      Nav01.Hints.Add('Next');
      Nav01.Hints.Add('Last');
      Nav01.Hints.Add('Edit');
      Nav01.Hints.Add('Post');
      Nav01.Hints.Add('Insert');
      Nav01.Hints.Add('Delete');
      Nav01.Hints.Add('Cancel');
    finally
      Nav01.Hints.EndUpdate;
    end;
    SetEvent(Nav01, Self, 'OnPost', 'Nav01Post');
    mTRONCO.SetParentComponent(WebPanel2);
    mTRONCO.Name := 'mTRONCO';
    mTRONCO.Left := 605;
    mTRONCO.Top := 145;
    mTRONCO.Width := 100;
    mTRONCO.Height := 24;
    mTRONCO.ChildOrder := 14;
    mTRONCO.HeightPercent := 100.000000000000000000;
    mTRONCO.TabOrder := 3;
    mTRONCO.Text := 'mTRONCO';
    mTRONCO.WidthPercent := 100.000000000000000000;
    mTRONCO.DataField := 'tronco';
    mTRONCO.DataSource := WebDTS;
    mEmailC.SetParentComponent(WebPanel2);
    mEmailC.Name := 'mEmailC';
    mEmailC.Left := 64;
    mEmailC.Top := 245;
    mEmailC.Width := 309;
    mEmailC.Height := 24;
    mEmailC.CharCase := wecLowerCase;
    mEmailC.ChildOrder := 14;
    mEmailC.HeightPercent := 100.000000000000000000;
    mEmailC.TabOrder := 4;
    mEmailC.WidthPercent := 100.000000000000000000;
    mEmailC.DataField := 'emailc';
    mEmailC.DataSource := WebDTS;
    mEmailNFe.SetParentComponent(WebPanel2);
    mEmailNFe.Name := 'mEmailNFe';
    mEmailNFe.Left := 378;
    mEmailNFe.Top := 245;
    mEmailNFe.Width := 327;
    mEmailNFe.Height := 24;
    mEmailNFe.CharCase := wecLowerCase;
    mEmailNFe.ChildOrder := 14;
    mEmailNFe.HeightPercent := 100.000000000000000000;
    mEmailNFe.TabOrder := 4;
    mEmailNFe.WidthPercent := 100.000000000000000000;
    mEmailNFe.DataField := 'nfe_email00';
    mEmailNFe.DataSource := WebDTS;
    mInscricaoEST.SetParentComponent(WebPanel2);
    mInscricaoEST.Name := 'mInscricaoEST';
    mInscricaoEST.Left := 431;
    mInscricaoEST.Top := 45;
    mInscricaoEST.Width := 147;
    mInscricaoEST.Height := 24;
    mInscricaoEST.ChildOrder := 14;
    mInscricaoEST.EditType := weNumeric;
    mInscricaoEST.HeightPercent := 100.000000000000000000;
    mInscricaoEST.TabOrder := 1;
    mInscricaoEST.WidthPercent := 100.000000000000000000;
    SetEvent(mInscricaoEST, Self, 'OnKeyUp', 'mCNPJKeyUp');
    mInscricaoEST.DataField := 'inscricaoest';
    mInscricaoEST.DataSource := WebDTS;
    mCidade.SetParentComponent(WebPanel2);
    mCidade.Name := 'mCidade';
    mCidade.Left := 378;
    mCidade.Top := 195;
    mCidade.Width := 221;
    mCidade.Height := 24;
    mCidade.ChildOrder := 14;
    mCidade.HeightPercent := 100.000000000000000000;
    mCidade.TabOrder := 1;
    mCidade.WidthPercent := 100.000000000000000000;
    SetEvent(mCidade, Self, 'OnKeyUp', 'mCNPJKeyUp');
    mCidade.DataField := 'cidade';
    mCidade.DataSource := WebDTS;
    mEstado.SetParentComponent(WebPanel2);
    mEstado.Name := 'mEstado';
    mEstado.Left := 639;
    mEstado.Top := 195;
    mEstado.Width := 66;
    mEstado.Height := 24;
    mEstado.ChildOrder := 14;
    mEstado.Color := clKhaki;
    mEstado.HeightPercent := 100.000000000000000000;
    mEstado.ReadOnly := True;
    mEstado.TabOrder := 3;
    mEstado.WidthPercent := 100.000000000000000000;
    mEstado.DataField := 'estado';
    mEstado.DataSource := WebDTS;
    cad_lMUNI.SetParentComponent(WebPanel2);
    cad_lMUNI.Name := 'cad_lMUNI';
    cad_lMUNI.Left := 605;
    cad_lMUNI.Top := 195;
    cad_lMUNI.Width := 21;
    cad_lMUNI.Height := 24;
    cad_lMUNI.Color := clSkyBlue;
    cad_lMUNI.ElementClassName := 'btn btn-light';
    cad_lMUNI.ElementFont := efCSS;
    cad_lMUNI.Font.Charset := ANSI_CHARSET;
    cad_lMUNI.Font.Color := clBlack;
    cad_lMUNI.Font.Height := -13;
    cad_lMUNI.Font.Name := 'Roboto';
    cad_lMUNI.Font.Style := [];
    cad_lMUNI.Glyph.LoadFromFile('Planta.WebPanel2.cad_lMUNI.Glyph.png');
    cad_lMUNI.HeightStyle := ssAuto;
    cad_lMUNI.HeightPercent := 100.000000000000000000;
    cad_lMUNI.ParentFont := False;
    cad_lMUNI.TabOrder := 3;
    cad_lMUNI.WidthPercent := 100.000000000000000000;
    mAtiva.SetParentComponent(WebPanel2);
    mAtiva.Name := 'mAtiva';
    mAtiva.Left := 725;
    mAtiva.Top := 45;
    mAtiva.Width := 88;
    mAtiva.Height := 24;
    mAtiva.ChildOrder := 14;
    mAtiva.Color := 13041606;
    mAtiva.EditType := weFloat;
    mAtiva.HeightPercent := 100.000000000000000000;
    mAtiva.ReadOnly := True;
    mAtiva.TabOrder := 5;
    mAtiva.Visible := False;
    mAtiva.WidthPercent := 100.000000000000000000;
    mAtiva.DataField := 'ativa';
    mAtiva.DataSource := WebDTS;
    WebDBEdit1.SetParentComponent(WebPanel2);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 584;
    WebDBEdit1.Top := 95;
    WebDBEdit1.Width := 121;
    WebDBEdit1.Height := 24;
    WebDBEdit1.ChildOrder := 14;
    WebDBEdit1.Color := clKhaki;
    WebDBEdit1.EditType := weFloat;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.ReadOnly := True;
    WebDBEdit1.TabOrder := 5;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'datacad';
    WebDBEdit1.DataSource := WebDTS;
    mIBGE.SetParentComponent(WebPanel2);
    mIBGE.Name := 'mIBGE';
    mIBGE.Left := 725;
    mIBGE.Top := 195;
    mIBGE.Width := 88;
    mIBGE.Height := 24;
    mIBGE.ChildOrder := 14;
    mIBGE.Color := 13041606;
    mIBGE.EditType := weFloat;
    mIBGE.HeightPercent := 100.000000000000000000;
    mIBGE.ReadOnly := True;
    mIBGE.TabOrder := 5;
    mIBGE.Visible := False;
    mIBGE.WidthPercent := 100.000000000000000000;
    mIBGE.DataField := 'ibge';
    mIBGE.DataSource := WebDTS;
    mContatoP.SetParentComponent(WebPanel2);
    mContatoP.Name := 'mContatoP';
    mContatoP.Left := 64;
    mContatoP.Top := 295;
    mContatoP.Width := 309;
    mContatoP.Height := 24;
    mContatoP.CharCase := wecLowerCase;
    mContatoP.ChildOrder := 14;
    mContatoP.HeightPercent := 100.000000000000000000;
    mContatoP.TabOrder := 4;
    mContatoP.WidthPercent := 100.000000000000000000;
    mContatoP.DataField := 'contatop';
    mContatoP.DataSource := WebDTS;
    mRegime.SetParentComponent(WebPanel2);
    mRegime.Name := 'mRegime';
    mRegime.Left := 725;
    mRegime.Top := 295;
    mRegime.Width := 88;
    mRegime.Height := 24;
    mRegime.ChildOrder := 14;
    mRegime.Color := 13041606;
    mRegime.EditType := weFloat;
    mRegime.HeightPercent := 100.000000000000000000;
    mRegime.TabOrder := 5;
    mRegime.Visible := False;
    mRegime.WidthPercent := 100.000000000000000000;
    mRegime.DataField := 'nfe_regimefiscal';
    mRegime.DataSource := WebDTS;
    cRegimeFiscal.SetParentComponent(WebPanel2);
    cRegimeFiscal.Name := 'cRegimeFiscal';
    cRegimeFiscal.Left := 488;
    cRegimeFiscal.Top := 295;
    cRegimeFiscal.Width := 217;
    cRegimeFiscal.Height := 24;
    cRegimeFiscal.HeightPercent := 100.000000000000000000;
    cRegimeFiscal.Text := 'cRegimeFiscal';
    cRegimeFiscal.WidthPercent := 100.000000000000000000;
    SetEvent(cRegimeFiscal, Self, 'OnClick', 'cRegimeFiscalClick');
    cRegimeFiscal.ItemIndex := -1;
    cRegimeFiscal.Items.BeginUpdate;
    try
      cRegimeFiscal.Items.Clear;
      cRegimeFiscal.Items.Add('1-Simples');
      cRegimeFiscal.Items.Add('2-Simples com excesso de sublimite');
      cRegimeFiscal.Items.Add('3-Lucro Presumido');
      cRegimeFiscal.Items.Add('4-Lucro Real');
    finally
      cRegimeFiscal.Items.EndUpdate;
    end;
    WebConn.SetParentComponent(Self);
    WebConn.Name := 'WebConn';
    WebConn.Active := False;
    WebConn.DataNode := 'data';
    WebConn.Delimiter := ';';
    WebConn.URI := 'http://localhost:8083/api/pessoafj?ativa=1';
    WebConn.Left := 316;
    WebConn.Top := 320;
    WebDTS.SetParentComponent(Self);
    WebDTS.Name := 'WebDTS';
    WebDTS.AutoEdit := False;
    WebDTS.DataSet := WebClientDS;
    SetEvent(WebDTS, Self, 'OnDataChange', 'WebDTSDataChange');
    WebDTS.Left := 504;
    WebDTS.Top := 320;
    upPlanta.SetParentComponent(Self);
    upPlanta.Name := 'upPlanta';
    upPlanta.Left := 635;
    upPlanta.Top := 457;
    WebClientDS.SetParentComponent(Self);
    WebClientDS.Name := 'WebClientDS';
    WebClientDS.Connection := WebConn;
    WebClientDS.BeforePost := WebClientDSBeforePost;
    WebClientDS.Left := 408;
    WebClientDS.Top := 320;
    WebClientDSidpess.SetParentComponent(WebClientDS);
    WebClientDSidpess.Name := 'WebClientDSidpess';
    WebClientDSidpess.FieldName := 'idpess';
    WebClientDSmarca.SetParentComponent(WebClientDS);
    WebClientDSmarca.Name := 'WebClientDSmarca';
    WebClientDSmarca.FieldName := 'marca';
    WebClientDSmarca.Size := 35;
    WebClientDSrazao.SetParentComponent(WebClientDS);
    WebClientDSrazao.Name := 'WebClientDSrazao';
    WebClientDSrazao.FieldName := 'razao';
    WebClientDSrazao.Size := 100;
    WebClientDSidgrupo.SetParentComponent(WebClientDS);
    WebClientDSidgrupo.Name := 'WebClientDSidgrupo';
    WebClientDSidgrupo.FieldName := 'idgrupo';
    WebClientDScnpj.SetParentComponent(WebClientDS);
    WebClientDScnpj.Name := 'WebClientDScnpj';
    WebClientDScnpj.FieldName := 'cnpj';
    WebClientDScnpj.Size := 18;
    WebClientDScnpj_serie.SetParentComponent(WebClientDS);
    WebClientDScnpj_serie.Name := 'WebClientDScnpj_serie';
    WebClientDScnpj_serie.FieldName := 'cnpj_serie';
    WebClientDSinscricaoest.SetParentComponent(WebClientDS);
    WebClientDSinscricaoest.Name := 'WebClientDSinscricaoest';
    WebClientDSinscricaoest.FieldName := 'inscricaoest';
    WebClientDSinscricaoest.Size := 256;
    WebClientDSendereco.SetParentComponent(WebClientDS);
    WebClientDSendereco.Name := 'WebClientDSendereco';
    WebClientDSendereco.FieldName := 'endereco';
    WebClientDSendereco.Size := 256;
    WebClientDStronco.SetParentComponent(WebClientDS);
    WebClientDStronco.Name := 'WebClientDStronco';
    WebClientDStronco.FieldName := 'tronco';
    WebClientDStronco.Size := 256;
    WebClientDSstatus.SetParentComponent(WebClientDS);
    WebClientDSstatus.Name := 'WebClientDSstatus';
    WebClientDSstatus.FieldName := 'status';
    WebClientDSstatus.Size := 256;
    WebClientDSbairro.SetParentComponent(WebClientDS);
    WebClientDSbairro.Name := 'WebClientDSbairro';
    WebClientDSbairro.FieldName := 'bairro';
    WebClientDSbairro.Size := 256;
    WebClientDScidade.SetParentComponent(WebClientDS);
    WebClientDScidade.Name := 'WebClientDScidade';
    WebClientDScidade.FieldName := 'cidade';
    WebClientDScidade.Size := 256;
    WebClientDScep.SetParentComponent(WebClientDS);
    WebClientDScep.Name := 'WebClientDScep';
    WebClientDScep.FieldName := 'cep';
    WebClientDScep.Size := 256;
    WebClientDSestado.SetParentComponent(WebClientDS);
    WebClientDSestado.Name := 'WebClientDSestado';
    WebClientDSestado.FieldName := 'estado';
    WebClientDSestado.Size := 256;
    WebClientDScomplemento.SetParentComponent(WebClientDS);
    WebClientDScomplemento.Name := 'WebClientDScomplemento';
    WebClientDScomplemento.FieldName := 'complemento';
    WebClientDScomplemento.Size := 256;
    WebClientDSativa.SetParentComponent(WebClientDS);
    WebClientDSativa.Name := 'WebClientDSativa';
    WebClientDSativa.FieldName := 'ativa';
    WebClientDSfilial.SetParentComponent(WebClientDS);
    WebClientDSfilial.Name := 'WebClientDSfilial';
    WebClientDSfilial.FieldName := 'filial';
    WebClientDSemailc.SetParentComponent(WebClientDS);
    WebClientDSemailc.Name := 'WebClientDSemailc';
    WebClientDSemailc.FieldName := 'emailc';
    WebClientDSemailc.Size := 256;
    WebClientDSnfe_email00.SetParentComponent(WebClientDS);
    WebClientDSnfe_email00.Name := 'WebClientDSnfe_email00';
    WebClientDSnfe_email00.FieldName := 'nfe_email00';
    WebClientDSnfe_email00.Size := 256;
    WebClientDScontatop.SetParentComponent(WebClientDS);
    WebClientDScontatop.Name := 'WebClientDScontatop';
    WebClientDScontatop.FieldName := 'contatop';
    WebClientDScontatop.Size := 256;
    WebClientDSsim_cpf.SetParentComponent(WebClientDS);
    WebClientDSsim_cpf.Name := 'WebClientDSsim_cpf';
    WebClientDSsim_cpf.FieldName := 'sim_cpf';
    WebClientDSbacen.SetParentComponent(WebClientDS);
    WebClientDSbacen.Name := 'WebClientDSbacen';
    WebClientDSbacen.FieldName := 'bacen';
    WebClientDSidcchain.SetParentComponent(WebClientDS);
    WebClientDSidcchain.Name := 'WebClientDSidcchain';
    WebClientDSidcchain.FieldName := 'idcchain';
    WebClientDSidseg.SetParentComponent(WebClientDS);
    WebClientDSidseg.Name := 'WebClientDSidseg';
    WebClientDSidseg.FieldName := 'idseg';
    WebClientDSdatacad.SetParentComponent(WebClientDS);
    WebClientDSdatacad.Name := 'WebClientDSdatacad';
    WebClientDSdatacad.FieldName := 'datacad';
    WebClientDSibge.SetParentComponent(WebClientDS);
    WebClientDSibge.Name := 'WebClientDSibge';
    WebClientDSibge.FieldName := 'ibge';
    WebClientDSibge.Size := 256;
    WebClientDSnfe_regimefiscal.SetParentComponent(WebClientDS);
    WebClientDSnfe_regimefiscal.Name := 'WebClientDSnfe_regimefiscal';
    WebClientDSnfe_regimefiscal.FieldName := 'nfe_regimefiscal';
    WebClientDSequalcmcarvalho.SetParentComponent(WebClientDS);
    WebClientDSequalcmcarvalho.Name := 'WebClientDSequalcmcarvalho';
    WebClientDSequalcmcarvalho.FieldName := 'equalcmcarvalho';
    WebClientDSok_cliente.SetParentComponent(WebClientDS);
    WebClientDSok_cliente.Name := 'WebClientDSok_cliente';
    WebClientDSok_cliente.FieldName := 'ok_cliente';
    WebClientDSok_forne.SetParentComponent(WebClientDS);
    WebClientDSok_forne.Name := 'WebClientDSok_forne';
    WebClientDSok_forne.FieldName := 'ok_forne';
    WebClientDSok_transp.SetParentComponent(WebClientDS);
    WebClientDSok_transp.Name := 'WebClientDSok_transp';
    WebClientDSok_transp.FieldName := 'ok_transp';
    WebClientDSok_repres.SetParentComponent(WebClientDS);
    WebClientDSok_repres.Name := 'WebClientDSok_repres';
    WebClientDSok_repres.FieldName := 'ok_repres';
    WebClientDSok_vend.SetParentComponent(WebClientDS);
    WebClientDSok_vend.Name := 'WebClientDSok_vend';
    WebClientDSok_vend.FieldName := 'ok_vend';
    WebClientDSok_compra.SetParentComponent(WebClientDS);
    WebClientDSok_compra.Name := 'WebClientDSok_compra';
    WebClientDSok_compra.FieldName := 'ok_compra';
    WebClientDSok_montadora.SetParentComponent(WebClientDS);
    WebClientDSok_montadora.Name := 'WebClientDSok_montadora';
    WebClientDSok_montadora.FieldName := 'ok_montadora';
    WebClientDSok_func.SetParentComponent(WebClientDS);
    WebClientDSok_func.Name := 'WebClientDSok_func';
    WebClientDSok_func.FieldName := 'ok_func';
    WebClientDSok_ppilha.SetParentComponent(WebClientDS);
    WebClientDSok_ppilha.Name := 'WebClientDSok_ppilha';
    WebClientDSok_ppilha.FieldName := 'ok_ppilha';
    WebClientDSinscricaom.SetParentComponent(WebClientDS);
    WebClientDSinscricaom.Name := 'WebClientDSinscricaom';
    WebClientDSinscricaom.FieldName := 'inscricaom';
    WebClientDSinscricaom.Size := 256;
    WebClientDSinscricaoccm.SetParentComponent(WebClientDS);
    WebClientDSinscricaoccm.Name := 'WebClientDSinscricaoccm';
    WebClientDSinscricaoccm.FieldName := 'inscricaoccm';
    WebClientDSinscricaoccm.Size := 256;
    WebClientDSnosso_num.SetParentComponent(WebClientDS);
    WebClientDSnosso_num.Name := 'WebClientDSnosso_num';
    WebClientDSnosso_num.FieldName := 'nosso_num';
    WebClientDSnosso_num.Size := 256;
    WebClientDSduns_number.SetParentComponent(WebClientDS);
    WebClientDSduns_number.Name := 'WebClientDSduns_number';
    WebClientDSduns_number.FieldName := 'duns_number';
    WebClientDSduns_number.Size := 256;
    WebClientDScpostal.SetParentComponent(WebClientDS);
    WebClientDScpostal.Name := 'WebClientDScpostal';
    WebClientDScpostal.FieldName := 'cpostal';
    WebClientDScpostal.Size := 256;
    WebClientDSendcob.SetParentComponent(WebClientDS);
    WebClientDSendcob.Name := 'WebClientDSendcob';
    WebClientDSendcob.FieldName := 'endcob';
    WebClientDSendcob.Size := 256;
    WebClientDSmunicob.SetParentComponent(WebClientDS);
    WebClientDSmunicob.Name := 'WebClientDSmunicob';
    WebClientDSmunicob.FieldName := 'municob';
    WebClientDSmunicob.Size := 256;
    WebClientDScepcob.SetParentComponent(WebClientDS);
    WebClientDScepcob.Name := 'WebClientDScepcob';
    WebClientDScepcob.FieldName := 'cepcob';
    WebClientDScepcob.Size := 256;
    WebClientDSbaicob.SetParentComponent(WebClientDS);
    WebClientDSbaicob.Name := 'WebClientDSbaicob';
    WebClientDSbaicob.FieldName := 'baicob';
    WebClientDSbaicob.Size := 256;
    WebClientDSufcob.SetParentComponent(WebClientDS);
    WebClientDSufcob.Name := 'WebClientDSufcob';
    WebClientDSufcob.FieldName := 'ufcob';
    WebClientDSufcob.Size := 256;
    WebClientDSendent.SetParentComponent(WebClientDS);
    WebClientDSendent.Name := 'WebClientDSendent';
    WebClientDSendent.FieldName := 'endent';
    WebClientDSendent.Size := 256;
    WebClientDScepent.SetParentComponent(WebClientDS);
    WebClientDScepent.Name := 'WebClientDScepent';
    WebClientDScepent.FieldName := 'cepent';
    WebClientDScepent.Size := 256;
    WebClientDSbaient.SetParentComponent(WebClientDS);
    WebClientDSbaient.Name := 'WebClientDSbaient';
    WebClientDSbaient.FieldName := 'baient';
    WebClientDSbaient.Size := 256;
    WebClientDSufent.SetParentComponent(WebClientDS);
    WebClientDSufent.Name := 'WebClientDSufent';
    WebClientDSufent.FieldName := 'ufent';
    WebClientDSufent.Size := 256;
    WebClientDScident.SetParentComponent(WebClientDS);
    WebClientDScident.Name := 'WebClientDScident';
    WebClientDScident.FieldName := 'cident';
    WebClientDScident.Size := 256;
    WebClientDStipopj.SetParentComponent(WebClientDS);
    WebClientDStipopj.Name := 'WebClientDStipopj';
    WebClientDStipopj.FieldName := 'tipopj';
    WebClientDStipovenda.SetParentComponent(WebClientDS);
    WebClientDStipovenda.Name := 'WebClientDStipovenda';
    WebClientDStipovenda.FieldName := 'tipovenda';
    WebClientDSobspj.SetParentComponent(WebClientDS);
    WebClientDSobspj.Name := 'WebClientDSobspj';
    WebClientDSobspj.FieldName := 'obspj';
    WebClientDSobspj.Size := 256;
    WebClientDSnfserieedi.SetParentComponent(WebClientDS);
    WebClientDSnfserieedi.Name := 'WebClientDSnfserieedi';
    WebClientDSnfserieedi.FieldName := 'nfserieedi';
    WebClientDSnfserieedi.Size := 256;
    WebClientDSbvqi.SetParentComponent(WebClientDS);
    WebClientDSbvqi.Name := 'WebClientDSbvqi';
    WebClientDSbvqi.FieldName := 'bvqi';
    WebClientDSconfere_carga.SetParentComponent(WebClientDS);
    WebClientDSconfere_carga.Name := 'WebClientDSconfere_carga';
    WebClientDSconfere_carga.FieldName := 'confere_carga';
    WebClientDSnato.SetParentComponent(WebClientDS);
    WebClientDSnato.Name := 'WebClientDSnato';
    WebClientDSnato.FieldName := 'nato';
    WebClientDSregimefiscal.SetParentComponent(WebClientDS);
    WebClientDSregimefiscal.Name := 'WebClientDSregimefiscal';
    WebClientDSregimefiscal.FieldName := 'regimefiscal';
    WebClientDSregimefiscal.Size := 256;
    WebClientDScontadeb_cm.SetParentComponent(WebClientDS);
    WebClientDScontadeb_cm.Name := 'WebClientDScontadeb_cm';
    WebClientDScontadeb_cm.FieldName := 'contadeb_cm';
    WebClientDScontacred_cs.SetParentComponent(WebClientDS);
    WebClientDScontacred_cs.Name := 'WebClientDScontacred_cs';
    WebClientDScontacred_cs.FieldName := 'contacred_cs';
    WebClientDScontacred_vp.SetParentComponent(WebClientDS);
    WebClientDScontacred_vp.Name := 'WebClientDScontacred_vp';
    WebClientDScontacred_vp.FieldName := 'contacred_vp';
    WebClientDScancelado.SetParentComponent(WebClientDS);
    WebClientDScancelado.Name := 'WebClientDScancelado';
    WebClientDScancelado.FieldName := 'cancelado';
    WebClientDSfornecabc.SetParentComponent(WebClientDS);
    WebClientDSfornecabc.Name := 'WebClientDSfornecabc';
    WebClientDSfornecabc.FieldName := 'fornecabc';
    WebClientDSfornecabc.Size := 256;
    WebClientDSclienteabc.SetParentComponent(WebClientDS);
    WebClientDSclienteabc.Name := 'WebClientDSclienteabc';
    WebClientDSclienteabc.FieldName := 'clienteabc';
    WebClientDSclienteabc.Size := 256;
    WebClientDSidbco.SetParentComponent(WebClientDS);
    WebClientDSidbco.Name := 'WebClientDSidbco';
    WebClientDSidbco.FieldName := 'idbco';
    WebClientDSidtpgto.SetParentComponent(WebClientDS);
    WebClientDSidtpgto.Name := 'WebClientDSidtpgto';
    WebClientDSidtpgto.FieldName := 'idtpgto';
    WebClientDSidtpgtocc.SetParentComponent(WebClientDS);
    WebClientDSidtpgtocc.Name := 'WebClientDSidtpgtocc';
    WebClientDSidtpgtocc.FieldName := 'idtpgtocc';
    WebClientDSidtpgtocd.SetParentComponent(WebClientDS);
    WebClientDSidtpgtocd.Name := 'WebClientDSidtpgtocd';
    WebClientDSidtpgtocd.FieldName := 'idtpgtocd';
    WebClientDSpedeae5.SetParentComponent(WebClientDS);
    WebClientDSpedeae5.Name := 'WebClientDSpedeae5';
    WebClientDSpedeae5.FieldName := 'pedeae5';
    WebClientDSpedeae9.SetParentComponent(WebClientDS);
    WebClientDSpedeae9.Name := 'WebClientDSpedeae9';
    WebClientDSpedeae9.FieldName := 'pedeae9';
    WebClientDSidformav.SetParentComponent(WebClientDS);
    WebClientDSidformav.Name := 'WebClientDSidformav';
    WebClientDSidformav.FieldName := 'idformav';
    WebClientDSidformac.SetParentComponent(WebClientDS);
    WebClientDSidformac.Name := 'WebClientDSidformac';
    WebClientDSidformac.FieldName := 'idformac';
    WebClientDSvdm4.SetParentComponent(WebClientDS);
    WebClientDSvdm4.Name := 'WebClientDSvdm4';
    WebClientDSvdm4.FieldName := 'vdm4';
    WebClientDSqdm4.SetParentComponent(WebClientDS);
    WebClientDSqdm4.Name := 'WebClientDSqdm4';
    WebClientDSqdm4.FieldName := 'qdm4';
    WebClientDSfreq4m.SetParentComponent(WebClientDS);
    WebClientDSfreq4m.Name := 'WebClientDSfreq4m';
    WebClientDSfreq4m.FieldName := 'freq4m';
    WebClientDSqpmatr.SetParentComponent(WebClientDS);
    WebClientDSqpmatr.Name := 'WebClientDSqpmatr';
    WebClientDSqpmatr.FieldName := 'qpmatr';
    WebClientDSqpm01.SetParentComponent(WebClientDS);
    WebClientDSqpm01.Name := 'WebClientDSqpm01';
    WebClientDSqpm01.FieldName := 'qpm01';
    WebClientDSqpm02.SetParentComponent(WebClientDS);
    WebClientDSqpm02.Name := 'WebClientDSqpm02';
    WebClientDSqpm02.FieldName := 'qpm02';
    WebClientDSqpm03.SetParentComponent(WebClientDS);
    WebClientDSqpm03.Name := 'WebClientDSqpm03';
    WebClientDSqpm03.FieldName := 'qpm03';
    WebClientDSqpm04.SetParentComponent(WebClientDS);
    WebClientDSqpm04.Name := 'WebClientDSqpm04';
    WebClientDSqpm04.FieldName := 'qpm04';
    WebClientDSqpm05.SetParentComponent(WebClientDS);
    WebClientDSqpm05.Name := 'WebClientDSqpm05';
    WebClientDSqpm05.FieldName := 'qpm05';
    WebClientDSqpm06.SetParentComponent(WebClientDS);
    WebClientDSqpm06.Name := 'WebClientDSqpm06';
    WebClientDSqpm06.FieldName := 'qpm06';
    WebClientDSqpm07.SetParentComponent(WebClientDS);
    WebClientDSqpm07.Name := 'WebClientDSqpm07';
    WebClientDSqpm07.FieldName := 'qpm07';
    WebClientDSqpm08.SetParentComponent(WebClientDS);
    WebClientDSqpm08.Name := 'WebClientDSqpm08';
    WebClientDSqpm08.FieldName := 'qpm08';
    WebClientDSqpm09.SetParentComponent(WebClientDS);
    WebClientDSqpm09.Name := 'WebClientDSqpm09';
    WebClientDSqpm09.FieldName := 'qpm09';
    WebClientDSqpm10.SetParentComponent(WebClientDS);
    WebClientDSqpm10.Name := 'WebClientDSqpm10';
    WebClientDSqpm10.FieldName := 'qpm10';
    WebClientDSqpm11.SetParentComponent(WebClientDS);
    WebClientDSqpm11.Name := 'WebClientDSqpm11';
    WebClientDSqpm11.FieldName := 'qpm11';
    WebClientDSqpm12.SetParentComponent(WebClientDS);
    WebClientDSqpm12.Name := 'WebClientDSqpm12';
    WebClientDSqpm12.FieldName := 'qpm12';
    WebClientDSvps11.SetParentComponent(WebClientDS);
    WebClientDSvps11.Name := 'WebClientDSvps11';
    WebClientDSvps11.FieldName := 'vps11';
    WebClientDSvps12.SetParentComponent(WebClientDS);
    WebClientDSvps12.Name := 'WebClientDSvps12';
    WebClientDSvps12.FieldName := 'vps12';
    WebClientDSvps13.SetParentComponent(WebClientDS);
    WebClientDSvps13.Name := 'WebClientDSvps13';
    WebClientDSvps13.FieldName := 'vps13';
    WebClientDSvps14.SetParentComponent(WebClientDS);
    WebClientDSvps14.Name := 'WebClientDSvps14';
    WebClientDSvps14.FieldName := 'vps14';
    WebClientDSvps15.SetParentComponent(WebClientDS);
    WebClientDSvps15.Name := 'WebClientDSvps15';
    WebClientDSvps15.FieldName := 'vps15';
    WebClientDSvpmatr.SetParentComponent(WebClientDS);
    WebClientDSvpmatr.Name := 'WebClientDSvpmatr';
    WebClientDSvpmatr.FieldName := 'vpmatr';
    WebClientDSvpm01.SetParentComponent(WebClientDS);
    WebClientDSvpm01.Name := 'WebClientDSvpm01';
    WebClientDSvpm01.FieldName := 'vpm01';
    WebClientDSvpm02.SetParentComponent(WebClientDS);
    WebClientDSvpm02.Name := 'WebClientDSvpm02';
    WebClientDSvpm02.FieldName := 'vpm02';
    WebClientDSvpm03.SetParentComponent(WebClientDS);
    WebClientDSvpm03.Name := 'WebClientDSvpm03';
    WebClientDSvpm03.FieldName := 'vpm03';
    WebClientDSvpm04.SetParentComponent(WebClientDS);
    WebClientDSvpm04.Name := 'WebClientDSvpm04';
    WebClientDSvpm04.FieldName := 'vpm04';
    WebClientDSvpm05.SetParentComponent(WebClientDS);
    WebClientDSvpm05.Name := 'WebClientDSvpm05';
    WebClientDSvpm05.FieldName := 'vpm05';
    WebClientDSvpm06.SetParentComponent(WebClientDS);
    WebClientDSvpm06.Name := 'WebClientDSvpm06';
    WebClientDSvpm06.FieldName := 'vpm06';
    WebClientDSvpm07.SetParentComponent(WebClientDS);
    WebClientDSvpm07.Name := 'WebClientDSvpm07';
    WebClientDSvpm07.FieldName := 'vpm07';
    WebClientDSvpm08.SetParentComponent(WebClientDS);
    WebClientDSvpm08.Name := 'WebClientDSvpm08';
    WebClientDSvpm08.FieldName := 'vpm08';
    WebClientDSvpm09.SetParentComponent(WebClientDS);
    WebClientDSvpm09.Name := 'WebClientDSvpm09';
    WebClientDSvpm09.FieldName := 'vpm09';
    WebClientDSvpm10.SetParentComponent(WebClientDS);
    WebClientDSvpm10.Name := 'WebClientDSvpm10';
    WebClientDSvpm10.FieldName := 'vpm10';
    WebClientDSvpm11.SetParentComponent(WebClientDS);
    WebClientDSvpm11.Name := 'WebClientDSvpm11';
    WebClientDSvpm11.FieldName := 'vpm11';
    WebClientDSvpm12.SetParentComponent(WebClientDS);
    WebClientDSvpm12.Name := 'WebClientDSvpm12';
    WebClientDSvpm12.FieldName := 'vpm12';
    WebClientDSvpmatrliq.SetParentComponent(WebClientDS);
    WebClientDSvpmatrliq.Name := 'WebClientDSvpmatrliq';
    WebClientDSvpmatrliq.FieldName := 'vpmatrliq';
    WebClientDSvpm01liq.SetParentComponent(WebClientDS);
    WebClientDSvpm01liq.Name := 'WebClientDSvpm01liq';
    WebClientDSvpm01liq.FieldName := 'vpm01liq';
    WebClientDSvpm02liq.SetParentComponent(WebClientDS);
    WebClientDSvpm02liq.Name := 'WebClientDSvpm02liq';
    WebClientDSvpm02liq.FieldName := 'vpm02liq';
    WebClientDSvpm03liq.SetParentComponent(WebClientDS);
    WebClientDSvpm03liq.Name := 'WebClientDSvpm03liq';
    WebClientDSvpm03liq.FieldName := 'vpm03liq';
    WebClientDSvpm04liq.SetParentComponent(WebClientDS);
    WebClientDSvpm04liq.Name := 'WebClientDSvpm04liq';
    WebClientDSvpm04liq.FieldName := 'vpm04liq';
    WebClientDSvpm05liq.SetParentComponent(WebClientDS);
    WebClientDSvpm05liq.Name := 'WebClientDSvpm05liq';
    WebClientDSvpm05liq.FieldName := 'vpm05liq';
    WebClientDSvpm06liq.SetParentComponent(WebClientDS);
    WebClientDSvpm06liq.Name := 'WebClientDSvpm06liq';
    WebClientDSvpm06liq.FieldName := 'vpm06liq';
    WebClientDSvpm07liq.SetParentComponent(WebClientDS);
    WebClientDSvpm07liq.Name := 'WebClientDSvpm07liq';
    WebClientDSvpm07liq.FieldName := 'vpm07liq';
    WebClientDSvpm08liq.SetParentComponent(WebClientDS);
    WebClientDSvpm08liq.Name := 'WebClientDSvpm08liq';
    WebClientDSvpm08liq.FieldName := 'vpm08liq';
    WebClientDSvpm09liq.SetParentComponent(WebClientDS);
    WebClientDSvpm09liq.Name := 'WebClientDSvpm09liq';
    WebClientDSvpm09liq.FieldName := 'vpm09liq';
    WebClientDSvpm10liq.SetParentComponent(WebClientDS);
    WebClientDSvpm10liq.Name := 'WebClientDSvpm10liq';
    WebClientDSvpm10liq.FieldName := 'vpm10liq';
    WebClientDSvpm11liq.SetParentComponent(WebClientDS);
    WebClientDSvpm11liq.Name := 'WebClientDSvpm11liq';
    WebClientDSvpm11liq.FieldName := 'vpm11liq';
    WebClientDSvpm12liq.SetParentComponent(WebClientDS);
    WebClientDSvpm12liq.Name := 'WebClientDSvpm12liq';
    WebClientDSvpm12liq.FieldName := 'vpm12liq';
    WebClientDSqvano.SetParentComponent(WebClientDS);
    WebClientDSqvano.Name := 'WebClientDSqvano';
    WebClientDSqvano.FieldName := 'qvano';
    WebClientDSpqvano.SetParentComponent(WebClientDS);
    WebClientDSpqvano.Name := 'WebClientDSpqvano';
    WebClientDSpqvano.FieldName := 'pqvano';
    WebClientDSfone.SetParentComponent(WebClientDS);
    WebClientDSfone.Name := 'WebClientDSfone';
    WebClientDSfone.FieldName := 'fone';
    WebClientDSfone.Size := 256;
    WebClientDSfax.SetParentComponent(WebClientDS);
    WebClientDSfax.Name := 'WebClientDSfax';
    WebClientDSfax.FieldName := 'fax';
    WebClientDSfax.Size := 256;
    WebClientDSemaile.SetParentComponent(WebClientDS);
    WebClientDSemaile.Name := 'WebClientDSemaile';
    WebClientDSemaile.FieldName := 'emaile';
    WebClientDSemaile.Size := 256;
    WebClientDSemailct.SetParentComponent(WebClientDS);
    WebClientDSemailct.Name := 'WebClientDSemailct';
    WebClientDSemailct.FieldName := 'emailct';
    WebClientDSemailct.Size := 256;
    WebClientDStipo_qc.SetParentComponent(WebClientDS);
    WebClientDStipo_qc.Name := 'WebClientDStipo_qc';
    WebClientDStipo_qc.FieldName := 'tipo_qc';
    WebClientDSicm_compra.SetParentComponent(WebClientDS);
    WebClientDSicm_compra.Name := 'WebClientDSicm_compra';
    WebClientDSicm_compra.FieldName := 'icm_compra';
    WebClientDSrespcad.SetParentComponent(WebClientDS);
    WebClientDSrespcad.Name := 'WebClientDSrespcad';
    WebClientDSrespcad.FieldName := 'respcad';
    WebClientDSrespcad.Size := 256;
    WebClientDSciclo_numped.SetParentComponent(WebClientDS);
    WebClientDSciclo_numped.Name := 'WebClientDSciclo_numped';
    WebClientDSciclo_numped.FieldName := 'ciclo_numped';
    WebClientDScode_transp.SetParentComponent(WebClientDS);
    WebClientDScode_transp.Name := 'WebClientDScode_transp';
    WebClientDScode_transp.FieldName := 'code_transp';
    WebClientDScodev_cfop.SetParentComponent(WebClientDS);
    WebClientDScodev_cfop.Name := 'WebClientDScodev_cfop';
    WebClientDScodev_cfop.FieldName := 'codev_cfop';
    WebClientDScodec_cfop.SetParentComponent(WebClientDS);
    WebClientDScodec_cfop.Name := 'WebClientDScodec_cfop';
    WebClientDScodec_cfop.FieldName := 'codec_cfop';
    WebClientDSnfe_assunto.SetParentComponent(WebClientDS);
    WebClientDSnfe_assunto.Name := 'WebClientDSnfe_assunto';
    WebClientDSnfe_assunto.FieldName := 'nfe_assunto';
    WebClientDSnfe_assunto.Size := 256;
    WebClientDSnfe_textoemail.SetParentComponent(WebClientDS);
    WebClientDSnfe_textoemail.Name := 'WebClientDSnfe_textoemail';
    WebClientDSnfe_textoemail.FieldName := 'nfe_textoemail';
    WebClientDSnfe_textoemail.Size := 256;
    WebClientDScontatom.SetParentComponent(WebClientDS);
    WebClientDScontatom.Name := 'WebClientDScontatom';
    WebClientDScontatom.FieldName := 'contatom';
    WebClientDScontatom.Size := 256;
    WebClientDSsim_mala.SetParentComponent(WebClientDS);
    WebClientDSsim_mala.Name := 'WebClientDSsim_mala';
    WebClientDSsim_mala.FieldName := 'sim_mala';
    WebClientDSnfe_amp.SetParentComponent(WebClientDS);
    WebClientDSnfe_amp.Name := 'WebClientDSnfe_amp';
    WebClientDSnfe_amp.FieldName := 'nfe_amp';
    WebClientDSrestr_fatmsg00.SetParentComponent(WebClientDS);
    WebClientDSrestr_fatmsg00.Name := 'WebClientDSrestr_fatmsg00';
    WebClientDSrestr_fatmsg00.FieldName := 'restr_fatmsg00';
    WebClientDSrestr_fatmsg00.Size := 256;
    WebClientDSrestr_fatflag00.SetParentComponent(WebClientDS);
    WebClientDSrestr_fatflag00.Name := 'WebClientDSrestr_fatflag00';
    WebClientDSrestr_fatflag00.FieldName := 'restr_fatflag00';
    WebClientDSinscritoie.SetParentComponent(WebClientDS);
    WebClientDSinscritoie.Name := 'WebClientDSinscritoie';
    WebClientDSinscritoie.FieldName := 'inscritoie';
    WebClientDSmkp.SetParentComponent(WebClientDS);
    WebClientDSmkp.Name := 'WebClientDSmkp';
    WebClientDSmkp.FieldName := 'mkp';
    WebClientDSsuframa.SetParentComponent(WebClientDS);
    WebClientDSsuframa.Name := 'WebClientDSsuframa';
    WebClientDSsuframa.FieldName := 'suframa';
    WebClientDSsuframa.Size := 256;
    WebClientDSsipi_pmp.SetParentComponent(WebClientDS);
    WebClientDSsipi_pmp.Name := 'WebClientDSsipi_pmp';
    WebClientDSsipi_pmp.FieldName := 'sipi_pmp';
    WebClientDSidvendedor.SetParentComponent(WebClientDS);
    WebClientDSidvendedor.Name := 'WebClientDSidvendedor';
    WebClientDSidvendedor.FieldName := 'idvendedor';
    WebClientDScomissao.SetParentComponent(WebClientDS);
    WebClientDScomissao.Name := 'WebClientDScomissao';
    WebClientDScomissao.FieldName := 'comissao';
    WebClientDSbaixarnfe_filhos.SetParentComponent(WebClientDS);
    WebClientDSbaixarnfe_filhos.Name := 'WebClientDSbaixarnfe_filhos';
    WebClientDSbaixarnfe_filhos.FieldName := 'baixarnfe_filhos';
    WebClientDSnfe_tpfrete.SetParentComponent(WebClientDS);
    WebClientDSnfe_tpfrete.Name := 'WebClientDSnfe_tpfrete';
    WebClientDSnfe_tpfrete.FieldName := 'nfe_tpfrete';
    WebClientDSp_pis.SetParentComponent(WebClientDS);
    WebClientDSp_pis.Name := 'WebClientDSp_pis';
    WebClientDSp_pis.FieldName := 'p_pis';
    WebClientDSp_cofins.SetParentComponent(WebClientDS);
    WebClientDSp_cofins.Name := 'WebClientDSp_cofins';
    WebClientDSp_cofins.FieldName := 'p_cofins';
    WebClientDSp_iss.SetParentComponent(WebClientDS);
    WebClientDSp_iss.Name := 'WebClientDSp_iss';
    WebClientDSp_iss.FieldName := 'p_iss';
    WebClientDSp_inss.SetParentComponent(WebClientDS);
    WebClientDSp_inss.Name := 'WebClientDSp_inss';
    WebClientDSp_inss.FieldName := 'p_inss';
    WebClientDSp_csl.SetParentComponent(WebClientDS);
    WebClientDSp_csl.Name := 'WebClientDSp_csl';
    WebClientDSp_csl.FieldName := 'p_csl';
    WebClientDSp_ir.SetParentComponent(WebClientDS);
    WebClientDSp_ir.Name := 'WebClientDSp_ir';
    WebClientDSp_ir.FieldName := 'p_ir';
    WebClientDSp_pispasep.SetParentComponent(WebClientDS);
    WebClientDSp_pispasep.Name := 'WebClientDSp_pispasep';
    WebClientDSp_pispasep.FieldName := 'p_pispasep';
    WebClientDSidbcod.SetParentComponent(WebClientDS);
    WebClientDSidbcod.Name := 'WebClientDSidbcod';
    WebClientDSidbcod.FieldName := 'idbcod';
    WebClientDScredita_pis.SetParentComponent(WebClientDS);
    WebClientDScredita_pis.Name := 'WebClientDScredita_pis';
    WebClientDScredita_pis.FieldName := 'credita_pis';
    WebClientDScredita_cofins.SetParentComponent(WebClientDS);
    WebClientDScredita_cofins.Name := 'WebClientDScredita_cofins';
    WebClientDScredita_cofins.FieldName := 'credita_cofins';
    WebClientDScreditap_pis.SetParentComponent(WebClientDS);
    WebClientDScreditap_pis.Name := 'WebClientDScreditap_pis';
    WebClientDScreditap_pis.FieldName := 'creditap_pis';
    WebClientDScreditap_cofins.SetParentComponent(WebClientDS);
    WebClientDScreditap_cofins.Name := 'WebClientDScreditap_cofins';
    WebClientDScreditap_cofins.FieldName := 'creditap_cofins';
    WebClientDStravap.SetParentComponent(WebClientDS);
    WebClientDStravap.Name := 'WebClientDStravap';
    WebClientDStravap.FieldName := 'travap';
    WebClientDSexnitemped.SetParentComponent(WebClientDS);
    WebClientDSexnitemped.Name := 'WebClientDSexnitemped';
    WebClientDSexnitemped.FieldName := 'exnitemped';
    WebClientDStnitemped.SetParentComponent(WebClientDS);
    WebClientDStnitemped.Name := 'WebClientDStnitemped';
    WebClientDStnitemped.FieldName := 'tnitemped';
    WebClientDSpdesc.SetParentComponent(WebClientDS);
    WebClientDSpdesc.Name := 'WebClientDSpdesc';
    WebClientDSpdesc.FieldName := 'pdesc';
    WebClientDSsim_cfinal.SetParentComponent(WebClientDS);
    WebClientDSsim_cfinal.Name := 'WebClientDSsim_cfinal';
    WebClientDSsim_cfinal.FieldName := 'sim_cfinal';
    WebClientDSidcnt.SetParentComponent(WebClientDS);
    WebClientDSidcnt.Name := 'WebClientDSidcnt';
    WebClientDSidcnt.FieldName := 'idcnt';
    WebClientDSautoexecute.SetParentComponent(WebClientDS);
    WebClientDSautoexecute.Name := 'WebClientDSautoexecute';
    WebClientDSautoexecute.FieldName := 'autoexecute';
    WebClientDSsim_deljit.SetParentComponent(WebClientDS);
    WebClientDSsim_deljit.Name := 'WebClientDSsim_deljit';
    WebClientDSsim_deljit.FieldName := 'sim_deljit';
    WebClientDSsim_delfor.SetParentComponent(WebClientDS);
    WebClientDSsim_delfor.Name := 'WebClientDSsim_delfor';
    WebClientDSsim_delfor.FieldName := 'sim_delfor';
    WebClientDSsim_excel.SetParentComponent(WebClientDS);
    WebClientDSsim_excel.Name := 'WebClientDSsim_excel';
    WebClientDSsim_excel.FieldName := 'sim_excel';
    WebClientDSsim_manual.SetParentComponent(WebClientDS);
    WebClientDSsim_manual.Name := 'WebClientDSsim_manual';
    WebClientDSsim_manual.FieldName := 'sim_manual';
    WebClientDSidpedf.SetParentComponent(WebClientDS);
    WebClientDSidpedf.Name := 'WebClientDSidpedf';
    WebClientDSidpedf.FieldName := 'idpedf';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    CloseData.AfterLoadDFMValues;
    RS.AfterLoadDFMValues;
    btnPesquisar.AfterLoadDFMValues;
    Msg01.AfterLoadDFMValues;
    btnExcluir.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    mCNPJ.AfterLoadDFMValues;
    mMarca.AfterLoadDFMValues;
    mCEP.AfterLoadDFMValues;
    mComplemento.AfterLoadDFMValues;
    mIdPess.AfterLoadDFMValues;
    mRazao.AfterLoadDFMValues;
    mLogra.AfterLoadDFMValues;
    Nav01.AfterLoadDFMValues;
    mTRONCO.AfterLoadDFMValues;
    mEmailC.AfterLoadDFMValues;
    mEmailNFe.AfterLoadDFMValues;
    mInscricaoEST.AfterLoadDFMValues;
    mCidade.AfterLoadDFMValues;
    mEstado.AfterLoadDFMValues;
    cad_lMUNI.AfterLoadDFMValues;
    mAtiva.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    mIBGE.AfterLoadDFMValues;
    mContatoP.AfterLoadDFMValues;
    mRegime.AfterLoadDFMValues;
    cRegimeFiscal.AfterLoadDFMValues;
    WebConn.AfterLoadDFMValues;
    WebDTS.AfterLoadDFMValues;
    upPlanta.AfterLoadDFMValues;
    WebClientDS.AfterLoadDFMValues;
    WebClientDSidpess.AfterLoadDFMValues;
    WebClientDSmarca.AfterLoadDFMValues;
    WebClientDSrazao.AfterLoadDFMValues;
    WebClientDSidgrupo.AfterLoadDFMValues;
    WebClientDScnpj.AfterLoadDFMValues;
    WebClientDScnpj_serie.AfterLoadDFMValues;
    WebClientDSinscricaoest.AfterLoadDFMValues;
    WebClientDSendereco.AfterLoadDFMValues;
    WebClientDStronco.AfterLoadDFMValues;
    WebClientDSstatus.AfterLoadDFMValues;
    WebClientDSbairro.AfterLoadDFMValues;
    WebClientDScidade.AfterLoadDFMValues;
    WebClientDScep.AfterLoadDFMValues;
    WebClientDSestado.AfterLoadDFMValues;
    WebClientDScomplemento.AfterLoadDFMValues;
    WebClientDSativa.AfterLoadDFMValues;
    WebClientDSfilial.AfterLoadDFMValues;
    WebClientDSemailc.AfterLoadDFMValues;
    WebClientDSnfe_email00.AfterLoadDFMValues;
    WebClientDScontatop.AfterLoadDFMValues;
    WebClientDSsim_cpf.AfterLoadDFMValues;
    WebClientDSbacen.AfterLoadDFMValues;
    WebClientDSidcchain.AfterLoadDFMValues;
    WebClientDSidseg.AfterLoadDFMValues;
    WebClientDSdatacad.AfterLoadDFMValues;
    WebClientDSibge.AfterLoadDFMValues;
    WebClientDSnfe_regimefiscal.AfterLoadDFMValues;
    WebClientDSequalcmcarvalho.AfterLoadDFMValues;
    WebClientDSok_cliente.AfterLoadDFMValues;
    WebClientDSok_forne.AfterLoadDFMValues;
    WebClientDSok_transp.AfterLoadDFMValues;
    WebClientDSok_repres.AfterLoadDFMValues;
    WebClientDSok_vend.AfterLoadDFMValues;
    WebClientDSok_compra.AfterLoadDFMValues;
    WebClientDSok_montadora.AfterLoadDFMValues;
    WebClientDSok_func.AfterLoadDFMValues;
    WebClientDSok_ppilha.AfterLoadDFMValues;
    WebClientDSinscricaom.AfterLoadDFMValues;
    WebClientDSinscricaoccm.AfterLoadDFMValues;
    WebClientDSnosso_num.AfterLoadDFMValues;
    WebClientDSduns_number.AfterLoadDFMValues;
    WebClientDScpostal.AfterLoadDFMValues;
    WebClientDSendcob.AfterLoadDFMValues;
    WebClientDSmunicob.AfterLoadDFMValues;
    WebClientDScepcob.AfterLoadDFMValues;
    WebClientDSbaicob.AfterLoadDFMValues;
    WebClientDSufcob.AfterLoadDFMValues;
    WebClientDSendent.AfterLoadDFMValues;
    WebClientDScepent.AfterLoadDFMValues;
    WebClientDSbaient.AfterLoadDFMValues;
    WebClientDSufent.AfterLoadDFMValues;
    WebClientDScident.AfterLoadDFMValues;
    WebClientDStipopj.AfterLoadDFMValues;
    WebClientDStipovenda.AfterLoadDFMValues;
    WebClientDSobspj.AfterLoadDFMValues;
    WebClientDSnfserieedi.AfterLoadDFMValues;
    WebClientDSbvqi.AfterLoadDFMValues;
    WebClientDSconfere_carga.AfterLoadDFMValues;
    WebClientDSnato.AfterLoadDFMValues;
    WebClientDSregimefiscal.AfterLoadDFMValues;
    WebClientDScontadeb_cm.AfterLoadDFMValues;
    WebClientDScontacred_cs.AfterLoadDFMValues;
    WebClientDScontacred_vp.AfterLoadDFMValues;
    WebClientDScancelado.AfterLoadDFMValues;
    WebClientDSfornecabc.AfterLoadDFMValues;
    WebClientDSclienteabc.AfterLoadDFMValues;
    WebClientDSidbco.AfterLoadDFMValues;
    WebClientDSidtpgto.AfterLoadDFMValues;
    WebClientDSidtpgtocc.AfterLoadDFMValues;
    WebClientDSidtpgtocd.AfterLoadDFMValues;
    WebClientDSpedeae5.AfterLoadDFMValues;
    WebClientDSpedeae9.AfterLoadDFMValues;
    WebClientDSidformav.AfterLoadDFMValues;
    WebClientDSidformac.AfterLoadDFMValues;
    WebClientDSvdm4.AfterLoadDFMValues;
    WebClientDSqdm4.AfterLoadDFMValues;
    WebClientDSfreq4m.AfterLoadDFMValues;
    WebClientDSqpmatr.AfterLoadDFMValues;
    WebClientDSqpm01.AfterLoadDFMValues;
    WebClientDSqpm02.AfterLoadDFMValues;
    WebClientDSqpm03.AfterLoadDFMValues;
    WebClientDSqpm04.AfterLoadDFMValues;
    WebClientDSqpm05.AfterLoadDFMValues;
    WebClientDSqpm06.AfterLoadDFMValues;
    WebClientDSqpm07.AfterLoadDFMValues;
    WebClientDSqpm08.AfterLoadDFMValues;
    WebClientDSqpm09.AfterLoadDFMValues;
    WebClientDSqpm10.AfterLoadDFMValues;
    WebClientDSqpm11.AfterLoadDFMValues;
    WebClientDSqpm12.AfterLoadDFMValues;
    WebClientDSvps11.AfterLoadDFMValues;
    WebClientDSvps12.AfterLoadDFMValues;
    WebClientDSvps13.AfterLoadDFMValues;
    WebClientDSvps14.AfterLoadDFMValues;
    WebClientDSvps15.AfterLoadDFMValues;
    WebClientDSvpmatr.AfterLoadDFMValues;
    WebClientDSvpm01.AfterLoadDFMValues;
    WebClientDSvpm02.AfterLoadDFMValues;
    WebClientDSvpm03.AfterLoadDFMValues;
    WebClientDSvpm04.AfterLoadDFMValues;
    WebClientDSvpm05.AfterLoadDFMValues;
    WebClientDSvpm06.AfterLoadDFMValues;
    WebClientDSvpm07.AfterLoadDFMValues;
    WebClientDSvpm08.AfterLoadDFMValues;
    WebClientDSvpm09.AfterLoadDFMValues;
    WebClientDSvpm10.AfterLoadDFMValues;
    WebClientDSvpm11.AfterLoadDFMValues;
    WebClientDSvpm12.AfterLoadDFMValues;
    WebClientDSvpmatrliq.AfterLoadDFMValues;
    WebClientDSvpm01liq.AfterLoadDFMValues;
    WebClientDSvpm02liq.AfterLoadDFMValues;
    WebClientDSvpm03liq.AfterLoadDFMValues;
    WebClientDSvpm04liq.AfterLoadDFMValues;
    WebClientDSvpm05liq.AfterLoadDFMValues;
    WebClientDSvpm06liq.AfterLoadDFMValues;
    WebClientDSvpm07liq.AfterLoadDFMValues;
    WebClientDSvpm08liq.AfterLoadDFMValues;
    WebClientDSvpm09liq.AfterLoadDFMValues;
    WebClientDSvpm10liq.AfterLoadDFMValues;
    WebClientDSvpm11liq.AfterLoadDFMValues;
    WebClientDSvpm12liq.AfterLoadDFMValues;
    WebClientDSqvano.AfterLoadDFMValues;
    WebClientDSpqvano.AfterLoadDFMValues;
    WebClientDSfone.AfterLoadDFMValues;
    WebClientDSfax.AfterLoadDFMValues;
    WebClientDSemaile.AfterLoadDFMValues;
    WebClientDSemailct.AfterLoadDFMValues;
    WebClientDStipo_qc.AfterLoadDFMValues;
    WebClientDSicm_compra.AfterLoadDFMValues;
    WebClientDSrespcad.AfterLoadDFMValues;
    WebClientDSciclo_numped.AfterLoadDFMValues;
    WebClientDScode_transp.AfterLoadDFMValues;
    WebClientDScodev_cfop.AfterLoadDFMValues;
    WebClientDScodec_cfop.AfterLoadDFMValues;
    WebClientDSnfe_assunto.AfterLoadDFMValues;
    WebClientDSnfe_textoemail.AfterLoadDFMValues;
    WebClientDScontatom.AfterLoadDFMValues;
    WebClientDSsim_mala.AfterLoadDFMValues;
    WebClientDSnfe_amp.AfterLoadDFMValues;
    WebClientDSrestr_fatmsg00.AfterLoadDFMValues;
    WebClientDSrestr_fatflag00.AfterLoadDFMValues;
    WebClientDSinscritoie.AfterLoadDFMValues;
    WebClientDSmkp.AfterLoadDFMValues;
    WebClientDSsuframa.AfterLoadDFMValues;
    WebClientDSsipi_pmp.AfterLoadDFMValues;
    WebClientDSidvendedor.AfterLoadDFMValues;
    WebClientDScomissao.AfterLoadDFMValues;
    WebClientDSbaixarnfe_filhos.AfterLoadDFMValues;
    WebClientDSnfe_tpfrete.AfterLoadDFMValues;
    WebClientDSp_pis.AfterLoadDFMValues;
    WebClientDSp_cofins.AfterLoadDFMValues;
    WebClientDSp_iss.AfterLoadDFMValues;
    WebClientDSp_inss.AfterLoadDFMValues;
    WebClientDSp_csl.AfterLoadDFMValues;
    WebClientDSp_ir.AfterLoadDFMValues;
    WebClientDSp_pispasep.AfterLoadDFMValues;
    WebClientDSidbcod.AfterLoadDFMValues;
    WebClientDScredita_pis.AfterLoadDFMValues;
    WebClientDScredita_cofins.AfterLoadDFMValues;
    WebClientDScreditap_pis.AfterLoadDFMValues;
    WebClientDScreditap_cofins.AfterLoadDFMValues;
    WebClientDStravap.AfterLoadDFMValues;
    WebClientDSexnitemped.AfterLoadDFMValues;
    WebClientDStnitemped.AfterLoadDFMValues;
    WebClientDSpdesc.AfterLoadDFMValues;
    WebClientDSsim_cfinal.AfterLoadDFMValues;
    WebClientDSidcnt.AfterLoadDFMValues;
    WebClientDSautoexecute.AfterLoadDFMValues;
    WebClientDSsim_deljit.AfterLoadDFMValues;
    WebClientDSsim_delfor.AfterLoadDFMValues;
    WebClientDSsim_excel.AfterLoadDFMValues;
    WebClientDSsim_manual.AfterLoadDFMValues;
    WebClientDSidpedf.AfterLoadDFMValues;
  end;
end;

end.
